// Static informational pages — verbatim content extracted from
// staging21.andersoncollege.com (Apr 2026).
//
// Sources:
//   /financial-aid/                         — FINANCIAL_AID
//   /contact/  (titled "Locations")          — CAMPUSES (10 sites)
//   /need-help/                              — NEED_HELP (Jotform embed)
//   user-supplied screenshot (Apr 2026)      — STUDENT_LIFE menu structure

const SUBPAGE_HERO_IMG =
  "/assets/migrated/1dd95d7e49-Frame-10-1.png";
// Authentic hero images extracted from staging Elementor CSS and copied locally
// from the WordPress media dump (parity audit, Apr 2026).
const FINANCIAL_AID_HERO_IMG = "/assets/heroes/financial-aid-hero.png"; // post-53 first background

// ───────────────────────────── Financial Aid ─────────────────────────────
export const FINANCIAL_AID = {
  hero: {
    eyebrow: "Financial Aid",
    title: "Financial Aid",
    subtitle:
      "Education is one of the most important investments in life. \u201CCan I afford it?\u201D is a question frequently asked by our students. We will be happy to help you review your options to finance your future.",
    image: FINANCIAL_AID_HERO_IMG,
    mobileImage: "/assets/heroes/financial-aid-hero-mobile.png",
  },
  intro: [
    "Anderson College knows first-hand how stressful and frightening it can be to establish a career in a new country or to build a career in a country you\u2019ve spent years in. Whether you\u2019ve selected the program or are just beginning your research of what Anderson College offers for some students, the financial aspect of paying for school can seem daunting.",
    "After being partner to thousands of students as they transitioned from student to success story, we can say with confidence that your career and your future are absolutely worth the investment and you can afford it.",
    "We want to make the financial part of this process as easy to navigate as possible, so you can get to start-date and then graduation day. We\u2019ve laid out some of the details that can help you below, or feel free to contact us directly and a member of our team will be happy to help you understand your options.",
  ],
  options: [
    {
      title: "College Interest-Free Financing",
      id: "interest-free-financing",
      body: "Anderson College provides interest-free financing for self-funded students. For more information, please contact us and speak to one of our advisors.",
    },
    {
      title: "Government Student Loans Ontario Student Assistance Program (OSAP)",
      id: "osap",
      body: "Financial assistance may be available to those who qualify. Please visit www.osap.gov.on.ca or contact us and we will help you navigate the information on the government website.",
      cta: { label: "Visit OSAP", href: "https://www.osap.gov.on.ca/" },
    },
    {
      title: "ESDC",
      id: "esdc",
      body: "The Government of Canada is helping to create an educated, skilled, and flexible workforce. They are investing in programs that help individuals and businesses succeed in today\u2019s economy and prepare for the jobs of the future.\n\nFor more information on this funding option, please contact us and speak to one of our advisors.",
    },
    {
      title: "Registered Education Savings Plans (RESP)",
      id: "resp",
      body: "Students who have been named a beneficiary under a family members\u2019 Registered Education Savings Plan (RESP), may use funds from the RESP to finance their education.",
    },
    {
      title: "Lifelong Learning Plan",
      id: "lifelong-learning-plan",
      body: "The Lifelong Learning Plan (LLP) allows you to withdraw from your RRSPs to finance full-time training or education for you or your spouse or common-law partner. For more information, please visit this link.",
      cta: {
        label: "Visit Canada.ca",
        href: "https://www.canada.ca/en/revenue-agency/services/tax/individuals/topics/rrsps-related-plans/lifelong-learning-plan.html",
      },
    },
    {
      title: "Ontario Job Grant",
      id: "ontario-job-grant",
      body: "The Ontario Job Grant provides an opportunity for employers to invest in their workforce with help from the government.",
      bullets: [
        "The Job Grant provides direct financial support to individual employers who wish to purchase training for their employees. It\u2019s available to small, medium, and large businesses with a plan to deliver short-term training to existing and new employees, and will:  Provide up to $10,000 in government support per person for training costs.",
        "Require employers to contribute one-third of the total costs. There is additional flexibility for small businesses to provide an in-kind contribution towards their share of the costs.",
        "Require training delivered by an eligible, third-party trainer.",
      ],
      cta: {
        label: "Read full program details on Ontario.ca",
        href: "https://www.ontario.ca/page/ontario-job-grant",
      },
      footer:
        "If you\u2019re an employer who needs to provide training for your employees, or an employee who wishes to inform your employer of the job grant and get training while employed, contact us to learn more. Applications are accepted on an ongoing basis and we will be happy to guide you through the process.",
    },
  ],
  banks: [
    {
      name: "The Bank Of Montreal",
      logo: "/assets/migrated/0e430a7c8e-BMO.png",
      url: "https://www.bmo.com/en-ca/main/personal/students/?ecid=va-AGILE37085STU1-MDBMO16",
    },
    {
      name: "TD Canada Trust Student Line Of Credit",
      logo: "/assets/migrated/538796d476-TD.png",
      url: "https://www.td.com/ca/en/personal-banking/products/borrowing/lines-of-credit/student-line-of-credit",
    },
    {
      name: "Royal Credit Line For Students",
      logo: "/assets/migrated/424faf9f9c-RBC.png",
      url: "https://www.rbcroyalbank.com/personal-loans/student-loans/overview.html",
    },
    {
      name: "CIBC Line of Credit For Students",
      logo: "/assets/migrated/947fcb91fa-Cibc.png",
      url: "https://www.cibc.com/en/student/student-lines-of-credit/education-line-of-credit.html",
    },
    {
      name: "Scotiabank Line of Credit For Students",
      logo: "/assets/migrated/550e1a5e59-SC.png",
      url: "https://www.scotiabank.com/ca/en/personal/loans-lines/line-of-credit/scotialine-personal-line-of-credit-students.html",
    },
  ],
  closing: {
    heading: "Want Help Navigating All the Options?",
    body:
      "No need to do it alone.\n\nContact a member of our Admissions team and we\u2019ll work with you to match your interests and goals to a program and walk you through the steps that lead to start-day and career success.",
    cta: { label: "Connect Now", href: "/contact" },
  },
};

// ───────────────────────────── Campuses ─────────────────────────────
// Verbatim from staging /contact/ ("Locations") page. Virtual Tour URLs
// preserved. Slugs match program_campus_mapping.json campus labels.
// Each campus:
//   - slug, name, address1, address2, phone, phoneHref, googleMapUrl, virtualTourUrl
//   - isUnderRenovation (CMS flag, boolean): when true, shows the orange
//     status indicator + "Under Renovation" alert banner. Toggle per-campus
//     when work is in progress.
export const CAMPUSES = [
  {
    slug: "brampton",
    name: "Brampton",
    address1: "499 Main Street South, Suite 60",
    address2: "Brampton, ON L6Y 1N7",
    phone: "1.833.787.1885",
    phoneHref: "tel:18337871885",
    googleMapUrl: "https://www.google.com/maps?q=Anderson+College+Brampton",
    virtualTourUrl: "/campuses/brampton",
    isUnderRenovation: false,
    details: {
      // Merged list: programs offered in-person at Brampton + every
      // program available online (online programs are accessible from
      // any campus). Single unified section — see Kitchener for the
      // same pattern.
      programs: [
        { name: "Accounting and Payroll Administration", slug: "accounting-and-payroll-administration" },
        { name: "Business Administration (Capstone)", slug: "business-administration" },
        { name: "Early Childcare Assistant", slug: "early-childcare-assistant" },
        { name: "Health Information Management", slug: "health-information-management" },
        { name: "Intra Oral Level I & II Dental Asst", slug: "intra-oral-dental-assistant" },
        { name: "IT Technician", slug: "information-technology-technician" },
        { name: "Computer System Technician – Networking", slug: "computer-system-technician-networking" },
        { name: "Law Enforcement / Police Foundations", slug: "law-enforcement-police-foundations" },
        { name: "Medical Esthetician", slug: "medical-esthetician" },
        { name: "Medical Office Administrator (Online)", slug: "medical-office-administrator-online" },
        { name: "Occupational Health and Safety", slug: "occupational-health-and-safety" },
        { name: "Personal Support Worker", slug: "personal-support-worker" },
        { name: "Supply Chain & Logistics", slug: "supply-chain-logistics" },
      ],
      onlinePrograms: [],
    },
  },
  {
    slug: "brantford",
    name: "Brantford",
    address1: "39 King George Road, Suite 104",
    address2: "Brantford, ON N3R 5K2",
    phone: "1.833.787.1885",
    phoneHref: "tel:18337871885",
    googleMapUrl: "https://www.google.com/maps?q=Anderson+College+Brantford",
    virtualTourUrl: "/campuses/brantford",
    isUnderRenovation: true,
    renovationLabel: "Major Renovation",
    renovationNote: "Major Renovation — call before visiting.",
    details: {
      // 2026-07-24 — tour URL recovered from Wayback archive of the legacy
      // andersoncollege.com/student-life/brantford(-campus)/ page.
      virtualTourEmbedUrl: "https://247virtualtours.com/overlay.php?id=733",
      // Brantford is under major renovation — visitors should call first.
      // Online programs remain available since they don't require a visit.
      programs: [
        { name: "Accounting and Payroll Administration", slug: "accounting-and-payroll-administration" },
        { name: "Business Administration (Capstone)", slug: "business-administration" },
        { name: "Early Childcare Assistant", slug: "early-childcare-assistant" },
        { name: "Health Information Management", slug: "health-information-management" },
        { name: "IT Technician", slug: "information-technology-technician" },
        { name: "Computer System Technician – Networking", slug: "computer-system-technician-networking" },
        { name: "Law Enforcement / Police Foundations", slug: "law-enforcement-police-foundations" },
        { name: "Medical Office Administrator (Online)", slug: "medical-office-administrator-online" },
        { name: "Occupational Health and Safety", slug: "occupational-health-and-safety" },
        { name: "Supply Chain & Logistics", slug: "supply-chain-logistics" },
      ],
      onlinePrograms: [],
    },
  },
  {
    slug: "hamilton",
    name: "Hamilton",
    address1: "31 King Street East, 2nd Floor",
    address2: "Hamilton, ON L8N 1A1",
    phone: "1.833.787.1885",
    phoneHref: "tel:18337871885",
    googleMapUrl: "https://www.google.com/maps?q=Anderson+College+Hamilton",
    virtualTourUrl: "/campuses/hamilton",
    isUnderRenovation: false,
    details: {
      // 2026-07-24 — tour URL confirmed by client: 747 (dental lab, Hamilton).
      virtualTourEmbedUrl: "https://247virtualtours.com/overlay.php?id=747",
      programs: [
        { name: "Accounting and Payroll Administration", slug: "accounting-and-payroll-administration" },
        { name: "Business Administration (Capstone)", slug: "business-administration" },
        { name: "Early Childcare Assistant", slug: "early-childcare-assistant" },
        { name: "Health Information Management", slug: "health-information-management" },
        { name: "Intra Oral Level I & II Dental Asst", slug: "intra-oral-dental-assistant" },
        { name: "IT Technician", slug: "information-technology-technician" },
        { name: "Computer System Technician – Networking", slug: "computer-system-technician-networking" },
        { name: "Law Enforcement / Police Foundations", slug: "law-enforcement-police-foundations" },
        { name: "Medical Laboratory Assistant Technician", slug: "medical-laboratory-assistant" },
        { name: "Occupational Health and Safety", slug: "occupational-health-and-safety" },
        { name: "Personal Support Worker", slug: "personal-support-worker" },
        { name: "Supply Chain & Logistics", slug: "supply-chain-logistics" },
      ],
      onlinePrograms: [],
    },
  },
  {
    slug: "kitchener",
    name: "Kitchener",
    address1: "248 Stirling Avenue South, Unit 14",
    address2: "Kitchener, ON N2G 4L1",
    phone: "1.833.787.1885",
    phoneHref: "tel:18337871885",
    googleMapUrl: "https://maps.app.goo.gl/9fGBwx5XFkDXx8XW9",
    googleMapEmbed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2891.5!2d-80.4925!3d43.4239!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDPCsDI1JzI2LjAiTiA4MMKwMjknMzMuMCJX!5e0!3m2!1sen!2sca!4v1717800000000",
    virtualTourUrl: "https://247virtualtours.com/overlay.php?id=734",
    isUnderRenovation: false,
    // 2026-06-03 — scraped from andersoncollege.com/student-life/kitchener/
    // and ported here for SEO + GEO parity with the legacy site.
    details: {
      heroImage: "/assets/heroes/contact-hero.jpg",
      tagline: "Career-focused diplomas in Healthcare, IT, Business & Law — in the heart of Waterloo Region.",
      about: [
        "Anderson College's Kitchener campus is conveniently located at 248 Stirling Avenue South, Unit 14, and is easily accessible by public transit or auto. Free parking is available for visitors, faculty and students.",
        "The Kitchener campus offers a wealth of opportunities across multiple disciplines. Here you can earn your Diploma or Certificate in Healthcare, Information Technology, Business, or Law & Police Foundations. Financial assistance is available to qualified students.",
        "Anderson College is one of Canada's oldest career colleges, having opened our first location in 1885. We have trained more than 150,000 students over 140+ years and remain an empowering partner for adult learners across Ontario.",
      ],
      // 2026-06-11 — Single unified list of every program offered at the
      // Kitchener campus (in-campus + online), sorted alphabetically. The
      // separate "Online Programs" section is intentionally suppressed for
      // Kitchener (onlinePrograms left empty) so visitors see ONE clean
      // list under "Programs at Kitchener".
      programs: [
        { name: "Accounting and Payroll Administration", slug: "accounting-and-payroll-administration" },
        { name: "Business Administration (Capstone)", slug: "business-administration" },
        { name: "Early Childcare Assistant", slug: "early-childcare-assistant" },
        { name: "Health Information Management", slug: "health-information-management" },
        { name: "Intra Oral Level I & II Dental Asst", slug: "intra-oral-dental-assistant" },
        { name: "IT Technician", slug: "information-technology-technician" },
        { name: "Computer System Technician – Networking", slug: "computer-system-technician-networking" },
        { name: "Medical Laboratory Assistant Technician", slug: "medical-laboratory-assistant" },
        { name: "Medical Office Administrator (Online)", slug: "medical-office-administrator-online" },
        { name: "Occupational Health and Safety", slug: "occupational-health-and-safety" },
        { name: "Personal Support Worker", slug: "personal-support-worker" },
        { name: "Supply Chain & Logistics", slug: "supply-chain-logistics" },
      ],
      // Intentionally empty so the "Study from Kitchener — 100% online"
      // section does not render — all programs (including online ones)
      // are merged into the single `programs` list above.
      onlinePrograms: [],
      videoEmbedUrl: "https://www.youtube.com/embed/4EhI2ljVJ40",
      videoTitle: "Inside Anderson College Kitchener",
      virtualTourEmbedUrl: "https://247virtualtours.com/overlay.php?id=734",
      campusPerks: [
        "Free on-site parking for visitors, students and faculty",
        "Easy public-transit access via Grand River Transit",
        "Dedicated student lounges and study spaces",
        "Hands-on labs aligned to each program's career path",
        "Career-services support from day one",
      ],
      seo: {
        sourceUrl: "/campuses/kitchener",
      },
    },
  },
  {
    slug: "london",
    name: "London",
    address1: "303 Richmond Street, Unit 100",
    address2: "London, ON N6B 2H8",
    phone: "1.833.787.1885",
    phoneHref: "tel:18337871885",
    googleMapUrl: "https://www.google.com/maps?q=Anderson+College+London+Ontario",
    virtualTourUrl: "/campuses/london",
    isUnderRenovation: false,
    details: {
      // 2026-07-24 — tour URL recovered from Wayback archive of the legacy
      // andersoncollege.com/student-life/london(-campus)/ page.
      virtualTourEmbedUrl: "https://247virtualtours.com/overlay.php?id=735",
      programs: [
        { name: "Accounting and Payroll Administration", slug: "accounting-and-payroll-administration" },
        { name: "Business Administration (Capstone)", slug: "business-administration" },
        { name: "Early Childcare Assistant", slug: "early-childcare-assistant" },
        { name: "Health Information Management", slug: "health-information-management" },
        { name: "Intra Oral Level I & II Dental Asst", slug: "intra-oral-dental-assistant" },
        { name: "IT Technician", slug: "information-technology-technician" },
        { name: "Computer System Technician – Networking", slug: "computer-system-technician-networking" },
        { name: "Law Enforcement / Police Foundations", slug: "law-enforcement-police-foundations" },
        { name: "Medical Laboratory Assistant Technician", slug: "medical-laboratory-assistant" },
        { name: "Medical Office Administrator (Online)", slug: "medical-office-administrator-online" },
        { name: "Occupational Health and Safety", slug: "occupational-health-and-safety" },
        { name: "Orthopaedic Technician", slug: "orthopaedic-technician" },
        { name: "Paralegal", slug: "paralegal" },
        { name: "Personal Support Worker", slug: "personal-support-worker" },
        { name: "Supply Chain & Logistics", slug: "supply-chain-logistics" },
      ],
      onlinePrograms: [],
    },
  },
  {
    slug: "mississauga-dundas",
    name: "Mississauga - Dundas",
    address1: "165 Dundas Street West, 3rd Floor",
    address2: "Mississauga, ON L5B 2N6",
    phone: "1.833.787.1885",
    phoneHref: "tel:18337871885",
    googleMapUrl: "https://www.google.com/maps?q=Anderson+College+Mississauga+Dundas",
    virtualTourUrl: "/campuses/mississauga-dundas",
    isUnderRenovation: false,
    details: {
      // 2026-07-24 — tour URL recovered from Wayback archive of the legacy
      // andersoncollege.com/student-life/mississauga-dundas(-campus)/ page.
      virtualTourEmbedUrl: "https://247virtualtours.com/overlay.php?id=748",
      programs: [
        { name: "Accounting and Payroll Administration", slug: "accounting-and-payroll-administration" },
        { name: "Business Administration (Capstone)", slug: "business-administration" },
        { name: "Early Childcare Assistant", slug: "early-childcare-assistant" },
        { name: "Health Information Management", slug: "health-information-management" },
        { name: "Intra Oral Level I & II Dental Asst", slug: "intra-oral-dental-assistant" },
        { name: "IT Technician", slug: "information-technology-technician" },
        { name: "Computer System Technician – Networking", slug: "computer-system-technician-networking" },
        { name: "Law Enforcement / Police Foundations", slug: "law-enforcement-police-foundations" },
        { name: "Medical Esthetician", slug: "medical-esthetician" },
        { name: "Medical Laboratory Assistant Technician", slug: "medical-laboratory-assistant" },
        { name: "Medical Office Administrator", slug: "medical-office-administrator" },
        { name: "Medical Office Administrator (Online)", slug: "medical-office-administrator-online" },
        { name: "Occupational Health and Safety", slug: "occupational-health-and-safety" },
        { name: "Personal Support Worker", slug: "personal-support-worker" },
        { name: "Pharmacy Technician", slug: "pharmacy-technician" },
        { name: "Supply Chain & Logistics", slug: "supply-chain-logistics" },
      ],
      onlinePrograms: [],
    },
  },
  {
    slug: "mississauga-hurontario",
    name: "Mississauga - Hurontario",
    address1: "3025 Hurontario Street, Suite 600",
    address2: "Mississauga, ON L5B 2N6",
    phone: "1.833.787.1885",
    phoneHref: "tel:18337871885",
    googleMapUrl: "https://www.google.com/maps?q=Anderson+College+Mississauga+Hurontario",
    virtualTourUrl:
      "/campuses/mississauga-hurontario",
    details: {
      // 2026-07-24 — tour URL recovered from Wayback archive of the legacy
      // andersoncollege.com/student-life/mississauga-hurontario(-campus)/ page.
      virtualTourEmbedUrl: "https://247virtualtours.com/overlay.php?id=721",
      programs: [
        { name: "Accounting and Payroll Administration", slug: "accounting-and-payroll-administration" },
        { name: "Business Administration (Capstone)", slug: "business-administration" },
        { name: "Early Childcare Assistant", slug: "early-childcare-assistant" },
        { name: "Health Information Management", slug: "health-information-management" },
        { name: "IT Technician", slug: "information-technology-technician" },
        { name: "Computer System Technician – Networking", slug: "computer-system-technician-networking" },
        { name: "Law Enforcement / Police Foundations", slug: "law-enforcement-police-foundations" },
        { name: "Medical Office Administrator (Online)", slug: "medical-office-administrator-online" },
        { name: "Occupational Health and Safety", slug: "occupational-health-and-safety" },
        { name: "Paralegal", slug: "paralegal" },
        { name: "Pharmacy Assistant", slug: "pharmacy-assistant" },
        { name: "Supply Chain & Logistics", slug: "supply-chain-logistics" },
      ],
      onlinePrograms: [],
    },
  },
  {
    slug: "north-york",
    name: "North York",
    address1: "5734 Yonge Street, Suite 100",
    address2: "North York, ON M2M 4E7",
    phone: "1.833.787.1885",
    phoneHref: "tel:18337871885",
    googleMapUrl: "https://maps.app.goo.gl/dvWVPEYADWDxQyJc7",
    virtualTourUrl: "/campuses/north-york",
    isUnderRenovation: false,
    details: {
      // 2026-07-24 — North York has THREE tours (confirmed by client).
      virtualTours: [
        { label: "10th Floor — 5775 Yonge St", url: "https://247virtualtours.com/overlay.php?id=728" },
        { label: "8th Floor — 5734 Yonge St", url: "https://247virtualtours.com/overlay.php?id=726" },
        { label: "Sonography Lab", url: "https://247virtualtours.com/overlay.php?id=740" },
      ],
      programs: [
        { name: "Accounting and Payroll Administration", slug: "accounting-and-payroll-administration" },
        { name: "Business Administration (Capstone)", slug: "business-administration" },
        { name: "Cardiology Technologist", slug: "cardiology-technologist" },
        { name: "Dental Radiography", slug: "dental-radiography" },
        { name: "Diagnostic Medical Sonographer", slug: "diagnostic-medical-sonographer" },
        { name: "Early Childcare Assistant", slug: "early-childcare-assistant" },
        { name: "Early Childhood Education", slug: "early-childhood-education" },
        { name: "Health Information Management", slug: "health-information-management" },
        { name: "Intra Oral Level I & II Dental Asst", slug: "intra-oral-dental-assistant" },
        { name: "IT Technician", slug: "information-technology-technician" },
        { name: "Computer System Technician – Networking", slug: "computer-system-technician-networking" },
        { name: "Law Enforcement / Police Foundations", slug: "law-enforcement-police-foundations" },
        { name: "Medical Laboratory Assistant Technician", slug: "medical-laboratory-assistant" },
        { name: "Medical Laboratory Technology Hybrid", slug: "medical-laboratory-technology" },
        { name: "Medical Office Administrator", slug: "medical-office-administrator" },
        { name: "Medical Office Administrator (Online)", slug: "medical-office-administrator-online" },
        { name: "Occupational Health and Safety", slug: "occupational-health-and-safety" },
        { name: "Personal Support Worker", slug: "personal-support-worker" },
        { name: "Supply Chain & Logistics", slug: "supply-chain-logistics" },
      ],
      onlinePrograms: [],
    },
  },
  {
    slug: "toronto",
    name: "Toronto",
    address1: "5775 Yonge Street, Suite 1006",
    address2: "North York, ON M2M 4J1",
    phone: "1.833.787.1885",
    phoneHref: "tel:18337871885",
    googleMapUrl: "https://www.google.com/maps?q=5734+Yonge+St+North+York+Toronto",
    virtualTourUrl: "/campuses/toronto",
    isUnderRenovation: false,
    details: {
      // 2026-07-24 — tour URL recovered from Wayback archive of the legacy
      // andersoncollege.com/student-life/toronto(-campus)/ page.
      virtualTourEmbedUrl: "https://247virtualtours.com/overlay.php?id=732",
      programs: [
        { name: "Accounting and Payroll Administration", slug: "accounting-and-payroll-administration" },
        { name: "Business Administration (Capstone)", slug: "business-administration" },
        { name: "Early Childcare Assistant", slug: "early-childcare-assistant" },
        { name: "Health Information Management", slug: "health-information-management" },
        { name: "IT Technician", slug: "information-technology-technician" },
        { name: "Computer System Technician – Networking", slug: "computer-system-technician-networking" },
        { name: "Law Enforcement / Police Foundations", slug: "law-enforcement-police-foundations" },
        { name: "Medical Esthetician", slug: "medical-esthetician" },
        { name: "Medical Office Administrator (Online)", slug: "medical-office-administrator-online" },
        { name: "Occupational Health and Safety", slug: "occupational-health-and-safety" },
        { name: "Supply Chain & Logistics", slug: "supply-chain-logistics" },
      ],
      onlinePrograms: [],
    },
  },
  {
    slug: "windsor",
    name: "Windsor",
    address1: "630 Tecumseh Rd E",
    address2: "Windsor, ON N8X 2S2",
    phone: "1.833.787.1885",
    phoneHref: "tel:18337871885",
    googleMapUrl: "https://www.google.com/maps?q=Anderson+College+Windsor",
    virtualTourUrl: "/campuses/windsor",
    isUnderRenovation: false,
    details: {
      // 2026-07-24 — tour URL recovered from Wayback archive of the legacy
      // andersoncollege.com/student-life/windsor(-campus)/ page.
      virtualTourEmbedUrl: "https://247virtualtours.com/overlay.php?id=736",
      programs: [
        { name: "Accounting and Payroll Administration", slug: "accounting-and-payroll-administration" },
        { name: "Business Administration (Capstone)", slug: "business-administration" },
        { name: "Early Childcare Assistant", slug: "early-childcare-assistant" },
        { name: "Health Information Management", slug: "health-information-management" },
        { name: "Intra Oral Level I & II Dental Asst", slug: "intra-oral-dental-assistant" },
        { name: "IT Technician", slug: "information-technology-technician" },
        { name: "Computer System Technician – Networking", slug: "computer-system-technician-networking" },
        { name: "Law Enforcement / Police Foundations", slug: "law-enforcement-police-foundations" },
        { name: "Medical Esthetician", slug: "medical-esthetician" },
        { name: "Medical Office Administrator (Online)", slug: "medical-office-administrator-online" },
        { name: "Occupational Health and Safety", slug: "occupational-health-and-safety" },
        { name: "Personal Support Worker", slug: "personal-support-worker" },
        { name: "Supply Chain & Logistics", slug: "supply-chain-logistics" },
      ],
      onlinePrograms: [],
    },
  },
];

export const CAMPUSES_HERO = {
  eyebrow: "Locations",
  title: "Locations",
  subtitle:
    "At Anderson College we are more than our programs and facilities; we are a team of caring individuals who are deeply committed to helping our students become skillful, confident and in-demand employees. With multiple locations across Ontario, we are recognized for our high-calibre faculty, hands-on, real-life career training and supportive culture.",
  image: "/assets/heroes/contact-hero.jpg",
  mobileImage: "/assets/heroes/contact-hero-mobile.png",
};

// ───────────────────────────── Student Life ─────────────────────────────
// Menu structure from user-supplied screenshot (Apr 2026). Most sub-pages
// are external (jotform, andersoncollege.com production, gmssp.org, blog).
// "Need Help?" embeds the Jotform iframe directly.
const PROD = "https://www.andersoncollege.com";

export const STUDENT_LIFE_HERO = {
  eyebrow: "Student Life",
  title: "Student Life",
  subtitle:
    "Beyond practical programs and real-life career training, your Anderson College experience is about being part of a community of support \u2014 a family \u2014 with the resources, wellness programs, and digital tools to help you thrive.",
  image: SUBPAGE_HERO_IMG,
};

export const STUDENT_LIFE_LINKS = [
  {
    slug: "student-portal",
    title: "Student Portal",
    summary: "Sign in to your Anderson College student portal to access your courses, grades and resources.",
    href: `${PROD}/student-portal/`,
    external: true,
  },
  {
    slug: "need-help",
    title: "Need Help?",
    summary: "Contact our campus support team and get quick help with admissions, programs, and student services.",
    href: "/student-life/need-help",
    external: false,
  },
  {
    slug: "opswa-membership",
    title: "Complimentary OPSWA Membership for Anderson Students",
    summary:
      "Anderson College has partnered with the Ontario Personal Support Worker Association (OPSWA) to provide complimentary student membership to every PSW student.",
    href: "/student-life/opswa-membership",
    external: false,
  },
  {
    slug: "odaa-membership",
    title: "Complimentary ODAA Membership",
    summary:
      "Anderson College Intra Oral Dental Assistant students receive a complimentary membership to the Ontario Dental Assistants Association (ODAA).",
    href: "/student-life/odaa-membership",
    external: false,
  },
  {
    slug: "gmssp",
    title: "GuardMe Student Support Program (GMSSP)",
    summary:
      "A free, virtual, easy-to-use mental health service offering multilingual support for students 24/7 to help deal with school, health, or other concerns. At Anderson, we care about you and your wellbeing.",
    href: "/student-life/gmssp",
    external: false,
  },
  {
    slug: "digital-credentials-faq",
    title: "Digital Credentials \u2013 Frequently Asked Questions",
    summary:
      "Frequently asked questions about Anderson College digital credentials \u2014 verifiable, shareable diplomas, certificates and transcripts you control.",
    href: "/student-life/digital-credentials-faq",
    external: false,
  },
  {
    slug: "resources",
    title: "Resources",
    summary: "Forms, guides and downloads for current Anderson College students.",
    href: "/student-life/resources",
    external: false,
  },
  {
    slug: "blog",
    title: "Blog",
    summary: "Latest news, success stories, career tips and Anderson Connect features from our community.",
    href: "/blog",
    external: false,
  },
];

// Need Help — internal sub-page rendering the Jotform embed (verbatim from
// staging /need-help/).
export const NEED_HELP = {
  hero: {
    eyebrow: "Student Life",
    title: "How May We Help You?",
    subtitle:
      "Choose your campus and let us know.\n\nTimes have changed. Though we do try our very best, you may find it difficult to reach us by phone. Use the form below to reach us for any assistance you may need. We will be just as quick to respond!",
    image: "/assets/heroes/need-help-hero.jpg",
    mobileImage: "/assets/heroes/need-help-hero-mobile.png",
  },
  jotformId: "222224651501241",
};

// GMSSP — verbatim from staging /guardme-student-support-program-gmssp/.
// Last verified 2026-04-25 (Section 2 audit). This page is content-rich:
// 6 feature cards + 3-step Get Started + closing CTA, all matching staging.
export const GMSSP = {
  hero: {
    eyebrow: "Student Life",
    title: "GuardMe Student Support Program",
    subtitle:
      "A virtual, easy-to-use mental health service, offering multilingual support for students 24/7 to help deal with school, health, or other concerns.",
    image: "/assets/heroes/gmssp-hero.png",
    mobileImage: "/assets/heroes/gmssp-hero-mobile.png",
  },
  intro:
    "At Anderson, we care about you and your wellbeing. We have partnered with GuardMe Student Support Program to provide our students with a free Mental Wellness Student Support Program (SSP). We recommend that you download the TELUS Health Student Support app as soon as possible so that you can benefit from the service. For more information, please visit: https://www.gmssp.org/en.html.",
  features: [
    {
      icon: "/assets/icons/gmssp/image-14.png",
      title: "24/7 Unlimited Support",
      body:
        "GuardMe Student Support Program (GMSSP) offers real-time support conveniently available 24/7 via the app, telephone and web.",
    },
    {
      icon: "/assets/icons/gmssp/image-15.png",
      title: "Completely Free Service",
      body:
        "GuardMe Student Support Program (GMSSP) is a free service provided by an advisor over the phone or online in your time of need.",
    },
    {
      icon: "/assets/icons/gmssp/image-16.png",
      title: "Service Provided in Your Language",
      body:
        "You will have access to a counsellor who speaks your language, understands your experience and your unique needs.",
    },
    {
      icon: "/assets/icons/gmssp/image-17.png",
      title: "Chat or Phone Support",
      body:
        "For those who are unable to download the app, GuardMe Student Support Program (GMSSP) is also accessible with a direct phone call to 1-844-451-9700.",
    },
    {
      icon: "/assets/icons/gmssp/image-18.png",
      title: "Fully Secure and Confidential",
      body:
        "The service is completely confidential within the limits of the law, so no one will ever know you used the program.",
    },
    {
      icon: "/assets/icons/gmssp/image-19.png",
      title: "Licensed Counsellors",
      body:
        "Counsellors are Masters level experts experienced in supporting domestic and international students.",
    },
  ],
  getStarted: {
    heading: "It takes just a few minutes to get started!",
    steps: [
      {
        text: "Download the TELUS Health Student Support App from either the Apple App Store or Google Play.",
        links: [
          { label: "Apple App Store", href: "https://apps.apple.com/ca/app/my-issp/id1112006222" },
          { label: "Google Play", href: "https://play.google.com/store/apps/details?id=com.onetapsolutions.morneau.myissp&hl=en" },
        ],
      },
      { text: "Complete your personal profile and select the language you would like the app to work in." },
      { text: "Enable important app notifications regarding new in-app content, as well as new support offerings." },
    ],
    crisisNote: "If you require immediate assistance in a crisis, please call 911.",
  },
  closing: {
    heading: "Want Help Navigating All the Options?",
    body:
      "No need to do it alone.\n\nContact a member of our Admissions team and we\u2019ll work with you to match your interests and goals to a program and walk you through the steps that lead to start-day and career success.",
    cta: { label: "Connect Now" },
  },
};


// Resources — verbatim from staging /resources/.
export const RESOURCES = {
  hero: {
    eyebrow: "Student Life",
    title: "Resources",
    subtitle:
      "We believe you have what it takes to succeed, we just prove that you can. And we know that the more resources you have, the faster you can reach those career and life goals.",
    image: "/assets/heroes/resources-hero.jpg",
  },
  intro:
    "If you\u2019re looking to be a skilled, confident and in-demand employee in a career that matters and leads to financial stability faster, you can use all the support and resources you can get your hands on. These are a few to get you started. Download any or all of these free publications.",
  documents: [
    {
      title: "Sexual Violence Policy",
      caption: "An educational environment free from sexual violence.",
      icon: "/assets/icons/resources/Frame-2121453707.png",
      url: "/assets/pdfs/Anderson-Sexual-Violence-Policy-Jan08_2024.pdf",
    },
    {
      title: "Key Performance Indicators",
      caption: "Key Performance Indicators (2023)",
      icon: "/assets/icons/resources/indicator-1.png",
      url: "/assets/pdfs/Anderson-College-of-Health-Business-and-Technology-_-KPI-2023.pdf",
    },
    {
      title: "Employee Sexual Misconduct Policy",
      caption: "An educational environment free from sexual violence.",
      icon: "/assets/icons/resources/Layer_1.png",
      url: "/assets/pdfs/Anderson-Employee-Sexual-Misconduct-Policy.pdf",
    },
    {
      title: "Anderson College Accessibility Policies",
      caption: "Accessibility Policy\nMulti- Year Accessibility Plan",
      icon: "/assets/icons/resources/Layer_1-1.png",
      url: "/assets/pdfs/MultiYear-Acessibility-Plan.pdf",
    },
  ],
};

// Digital Credentials FAQ — verbatim from staging
// /digital-credentials-frequently-asked-questions/. Body intro paragraphs +
// 4 feature blocks (Always Accessible / Privacy / Learning Verified / Easily
// Share-able) + 16 FAQ Q&A items grouped into 3 sections.
export const DIGITAL_CREDS = {
  hero: {
    eyebrow: "Student Life",
    title: "Digital Credentials \u2013 Frequently Asked Questions",
    subtitle:
      "We\u2019re committed to providing you with the tools you need to advance your career, and we know that being able to communicate your Anderson credentials is a necessary step for you.",
    image: "/assets/heroes/digital-credentials-hero.png",
    mobileImage: "/assets/heroes/digital-credentials-hero-mobile.png",
  },
  // Walk-through video embedded from staging
  // (/digital-credentials-frequently-asked-questions/).
  // Source: https://youtu.be/iad7NMGvGDE
  videos: [
    {
      title: "How to access and share your Anderson Digital Credential",
      videoId: "iad7NMGvGDE",
    },
  ],
  intro:
    "With your digital diploma / certificate, your Anderson credentials can easily be verified at any time. Current and prospective clients and employers can quickly view your credentials status, and the online view of your diploma / certificate will communicate it\u2019s up-to-date status to anyone attempting to verify it. Your digital diploma / certificate allows you to stand out as a certified expert in the industry, and gives you verified credibility.",
  features: [
    {
      title: "Always Accessible",
      body:
        "Never worry about losing your diploma / certificate \u2013 ever. Your credential will always be present at its web address. If you\u2019ve misplaced a credential link, retrieve all of your Accredible credentials at any time by entering your email.",
    },
    {
      title: "Control Your Privacy",
      body:
        "Take advantage of searchability and have your achievement be discoverable on search engines, or set it to private and share with only selected people. How and when you share your badge is up to you.",
    },
    {
      title: "Learning, Verified",
      body:
        "Your achievements can be verified at any time. Your certifications on LinkedIn can be linked to your live badge so anyone, anywhere can see what you have achieved. A directory lets searchers quickly and definitively validate an Accredible badge.",
    },
    {
      title: "Easily Share-able",
      body:
        "You want to share your achievement. Accredible credentials let you showcase your achievement on Facebook, Twitter, and LinkedIn with one click. You can also download and include badges in your email signature, to demonstrate to colleagues, students, and others all of your professional development accomplishments.",
    },
  ],
  faqGroups: [
    {
      heading: "Accessing Your Credential",
      items: [
        // Source: staging /digital-credentials-frequently-asked-questions/
        // Verbatim restore (text-only — renderer is whitespace-pre-line; bold
        // and italic from staging are dropped but wording is preserved).
        // Last verified 2026-04-25 against rendered staging page.
        {
          q: "How Do I Login to My Credentials?",
          a: "There are two different methods for logging into credentials:\n\n1) First-time access through your credential delivery email\n\n2) Signing in at www.credential.net\n\nFirst Time Access through Credential Delivery Email\n\nWhen your credential is issued to you, an email will be sent to you containing a link to view your credential. Using this link for the first time will automatically sign you into you new credential. You will be prompted to set a password for your credential wallet.\n\nSetting a password for your credential wallet will ensure that you will always have access to all available features for your credentials, as well as private credentials.\n\nUsing the \u2018View my Credential\u2019 button will only sign you in to your wallet the first time you use it. Subsequent uses of the \u2018View my Credential\u2019 button or link from your email will direct you to the public view of your credential. You will need to sign in manually to access private features and credentials.\n\nHow do I sign into my credential/wallet?\n\n1. Navigate to www.credential.net on your internet browser\n2. In the top right-hand corner of the page, click on \u2018Sign In\u2019\n3. The sign-in box will pop up, prompting you to enter your email address and password for your Accredible Dashboard. Enter these and click \u2018Sign In\u2019\n\nCreating a Password\n\nIf you have not created a password for yourself yet, use the \u2018Forgot your password?\u2019 function and follow the prompts to set yourself one.\n\nLost or Forgotten Your Password?\n\nIf you have forgotten the password for your Accredible Dashboard, use the \u2018Forgot your password?\u2019 function and follow the prompts to issue yourself a new password.\n\nStaying Logged In\n\nYour Accredible account should remain logged in until either you delete your browser history or log out.\n\nTo keep your credential data secure, we recommend that you log out of Accredible after every use if you are on a shared computer. You want to prevent access to your account from either allowing creating or editing fraudulent credentials.",
        },
        {
          q: "Am I Signed In?",
          a: "If you are not signed in to credential.net, you will see the \u2018Sign In\u2019 button at the top right-hand corner of your credential view. If you are signed in, your name will appear in the top right-hand corner of the credential view.\n\nSigning In to Your Credential\n\n1. Click on the \u2018Sign In\u2019 button at the top right-hand corner of your credential view\n\nor\n\nClick on the \u2018Sign in to access more options\u2019 located below the certificate view (preferred)\n\nor\n\nNavigate to www.credential.net to sign in to your credential.\n2. Use the email address your credential was sent to and the email address you created for your credentials. If you have not yet set up a password for your credentials, use the \u2018Forgot Password?\u2019 function to create one for yourself now.\n3. Once you have successfully signed in, all available options will now be visible.",
        },
        {
          q: "I\u2019ve Lost My Certificate/ Badge Email. How Can I Find My Credentials Again?",
          a: "If you have lost the link or email for your Accredible certificate or badge, we have a handy tool that can help you get it back in a snap!\n\nRetrieve Credentials\n\n1. Head to our online Credential Retrieval Tool.\n2. Please enter the email that you received your credential with. It\u2019s important that you use the right email address, as this is how we identify your credentials.\n3. Click the \u2018Retrieve My Credentials\u2019\n4. We will then send you an email with links to all the certificates that belong to the email address you provided.",
        },
        {
          q: "Why is My Credential Unavailable?",
          a: "If you are trying to view your credential and see the message displayed below, your credential has not yet been published, has been deleted, or is set to private, and you are signed out.\n\nThe best thing to do is to contact Anderson College at helpdesk@andersoncollege.com to ask why your credential is unavailable.",
        },
        {
          q: "I Haven\u2019t Received My Credential",
          a: "If you are waiting for your digital certificate of badge to arrive, you can check a couple of places.\n\nCheck Your Spam/Junk Inbox or Security Software\n\nWe know! This is the oldest piece of advice in email history, but it is always worth pointing out. Your credential email may have accidentally ended up in your junk inbox, so if you haven\u2019t already, we recommend looking in there to be sure.\n\nLog In to Credential.Net\n\nIf you know the email address that your credential is going to be sent to, then you can try logging into the system that houses all of the digital certificates we issue:\n\n1. Go to credential.net\n2. Click on \u2018Sign In\u2019 at the top right-hand corner of the webpage\n3. Use the \u2018forgot your password\u2019 function to set a new password, using the email address you believe your credential has been issued to.\n4. If there are credentials on our system attached to the email address you have provided, you will be able to set yourself a password and sign in to see them. If the system does not recognize your email address, we do not have any credentials attached to the email address.\n\nUse our Retrieve Credential Tool\n\nIf you have a corporate or educational email address, your credential delivery email may have been blocked or filtered on its way to you.\n\nIn order to fetch your credential, you can use our handy Retrieve Credentials Tool. By entering in your email address, a list of all the credentials issued to you via Accredible will be sent to your email inbox for you to access immediately.\n\nWe have found that the Retrieve Tool often bypasses the same delivery problems as normal credential emails, and you can use it whenever you need it in order to retrieve the unique URLs for your credentials.\n\nA quick note, the email address you enter into the retrieve tool should be the same as the one you signed up for your course with, as this is likely the email address your credential is published under.\n\nContact Anderson College\n\nIf you do not know your email or cannot see the email address you registered your credential with, you will need to contact Anderson College at helpdesk@andersoncollege.com to discuss the nature of the delay.",
        },
      ],
    },
    {
      heading: "Using Your Credential",
      items: [
        // Source: staging /digital-credentials-frequently-asked-questions/
        // Verbatim restore. Last verified 2026-04-25.
        {
          q: "How Do I Add Credentials to my Mobile Digital Wallet?",
          a: "Accredible\u2019s badges and certificates are now available for you to verify your professional credentials on a job site or to prove your association membership right from your mobile device.\n\nHow to Add Credentials to Digital Mobile Wallet\n\nIf your credentials are Digital Wallet Pass enabled here is how to add them to your smart device\u2019s digital pass app.\n\nImportant: Your credential will need to have its privacy set to \u2018Public\u2019 in order to be able to use your credential in your digital mobile wallet.\n\n1. Using the browser app of your choice on your smart device, go to your credential view page using its unique URL.\n2. Sign in to your credential to access private features.\n3. Once signed in to your credential on your smart device you will see the option to \u2018Add to Mobile Wallet\u2019 under your credential, click \u2018Preview\u2019.\n\n1. You will be taken to the Wallet Pass Preview page which displays how your credential will be presented in your mobile wallet.\n2. At the bottom of the preview, Apple users will see the option to add to Apple Wallet. Android users will see the option to add to Google Pay. You must have the Apple Wallet app or Google Pay app installed on to your Apple or Android device respectively.\n3. Follow the instructions for the wallet app you are using to complete the addition of your credential.\n\nUsing your Digital Wallet Pass Credential\n\nSharing and verifying your credentials on the move is now simple.\n\nQR Code\n\nPresent the QR code from your Digital Wallet Pass so that third-parties can scan it and be taken straight to your live credential view on credential.net\n\nSharing\n\nUse your Digital Wallet app\u2019s share function to provide third-parties with your credentials should they need to view and verify them.",
        },
        {
          q: "How Can I Use My Credential\u2019s Unique URL?",
          a: "The Unique URL is the most valuable way you have of sharing your credential.\n\nLocating Your Unique Credential URL\n\nUpon viewing your credential on the Credential View page, your unique credential URL can be located within the web address bar of your web browser.\n\nWhy the URL is Important\n\nYou can place your credential\u2019s unique URL in a large variety of places, including:\n\n\u2022 Social Media Profiles\n\u2022 Websites and Blogs\n\u2022 Digital Resumes\n\u2022 Email Signatures\n\u2022 Where ever you can think of!\n\nBy doing this, you can direct stakeholders, such as admissions officers, potential employers, or customers, back to your Credential View.\n\nBy directing people interested in your credential back to the Credential View, they can verify the credential\u2019s validity and see more information about what that achievement entails, and better understand how you won the achievement.\n\nKeep it Safe\n\nAfter receiving the URL to your credential, it\u2019s a good idea to record and store the URL somewhere on your computer for later reference.\n\nTop Tip: If you lose the link to your credential, you can use the Retrieve Credentials Tool. This page will fetch any credentials associated with a recipient\u2019s email address and send them links to each credential.",
        },
        {
          q: "How Can I Download and Print My Certificate?",
          a: "The valuable part of your digital certificate is the unique, verifiable URL. However, it\u2019s also nice to have a hard copy of your credential. Here we show you how to download and print your certificate.\n\nDownload a PDF Version of your Certificate\n\n1. Navigate to the certificate that you would like to download.\n2. Along the bottom of the credential window, click the \u2018PDF\u2019 button.\n3. A PDF version of your credential will appear. Save this on to your computer.\n\nDownload and Print the Certificate\n\nTo print your certificate, you need to download a PDF copy first:\n\n1. Along the bottom of the credential window, click the \u2018PDF\u2019 button.\n2. A PDF copy of your certificate will open in a new browser window. Click on the download icon at the top of your PDF window.\n3. Open the PDF version of your certificate now downloaded to your computer. Go to \u2018File\u2019 at the top of your screen, then click on \u2018Print.\u2019\n4. Follow the printing instructions of your computer.\n\nOn modern-day browsers, you can seamlessly view and print your certificate without leaving your browser.",
        },
        {
          q: "How Do I Download a Digital Badge?",
          a: "You can download your digital badge to store it on your computer.\n\nDownload a PNG file of your Badge\n\n1. Navigate to the Credential View of the Badge you would like to download.\n2. Along the bottom of the credential window, click the \u2018Badge\u2019 button.",
        },
        {
          q: "How Do I Embed a Credential to my Email Signature?",
          a: "Embed your Digital Open Badge into your email signature so that everyone seeing your emails has the opportunity to check out your live credential.\n\nEmbedding into an email signature works best with badges instead of certificates, which can look too big and bulky at the bottom of an email. For this article, we will only refer to embedding badges.\n\nIf you have a certificate and a badge for your achievement, you can embed the badge in your email signature, and with one click, people can be sent to view the whole certificate.\n\nEven if you have a badge to embed and no certificate, having it lead back to your badge\u2019s live credential view helps people verify its validity.\n\nEmbed the Badge\n\n1. Go to the credential view of the badge you would like to embed.\n\n2. At the bottom of the credential window, click on the \u2018Embed\u2019 button.\n\nIf this feature appears grayed out or not visible, you may need to sign in to your credential to access it.\n\nEmbed into Gmail Signature\n\n01. In the \u2018Embed Credential\u2019 window that appears, click the \u2018Gmail Signature\u2019 tab at the top of the window and then the \u2018Copy Link\u2019 button next to your Badge Image URL.\n02. In a separate tab of your internet browser, open your Gmail account and click the cog icon (Settings) at the top right-hand corner of your view. In the drop-down menu, click \u2018See all settings.\u2019\n03. Scroll down to the \u2018Signature\u2019 section. [Create a new signature if needed.]\n04. Click on the \u2018Insert Image\u2019 button at the top of the signature toolbar, then to the Web Address (URL) tab.\n05. Paste the Badge Image URL that you copied from the \u2018Embed Credential\u2019 window earlier.\n06. Once the badge image has appeared, click on \u2018Select\u2019 at the bottom left-hand corner of the window.\n07. The badge will now appear in your email signature. You can select the image and resize it to small, medium, or large if you like.\n08. Go back to the tab of your credential view. In the \u2018Embed Credential\u2019 window, highlight and copy your credential\u2019s URL of Step 5.\n09. Go back to the tab with your Gmail account signature settings and Highlight the badge image and click the \u2018Link\u2019 tool at the top of the signature toolbar.\n10. In the box marked \u2018To what URL should this link go?\u2019 past the URL you just copied, then click \u2018OK\u2019 at the bottom right-hand corner of the window.\n11. Once you are happy with the appearance of your overall signature line, scroll to the bottom of your Gmail settings and click \u2018Save Changes.\u2019\n\nEmbed into Outlook Signature\n\n1. In the \u2018Embed Credential\u2019 window that appears, click the \u2018Outlook Signature\u2019 tab at the top of the window, then right-click the image of your badge. Select \u2018Save Image As\u2019 and download the badge onto your computer.\n2. Open Microsoft Outlook and click on \u2018New Email.\u2019\n3. In the new message, the window goes to the \u2018Signatures\u2019 and clicks on \u2018Signatures\u2019 from the drop-down menu.\n4. Either create a new signature or select an existing one to edit.\n5. To the far right of the signature editing toolbar, select \u2018Add Image\u2019 and select the image of the badge you just downloaded.\n6. Go back to the tab of your credential view. In the \u2018Embed Credential\u2019 window, highlight and copy the red text, which is your credential\u2019s URL.\n7. Highlight the badge you have just uploaded to your signature and click the \u2018Link\u2019 button at the far right-hand side of the toolbar.\n8. Paste the credential URL into the \u2018Address\u2019 field at the bottom of the window that appears, then click \u2018OK.\u2019\n9. Once you are happy with the appearance of your overall signature line, click \u2018OK\u2019 to save.\n\nOther Email Clients\n\nIf you use an email client other than Gmail or Outlook, such as Yahoo, Hotmail, or Mac Mail, we recommend:\n\n1. Downloading the PNG of your badge using the \u2018Download Badge\u2019 function in the left-hand sidebar of the credential view.\n\n2. Go into the signature settings of your particular email client and inserting the PNG.\n\n3. Highlight the badge image and use your email client\u2019s \u2018Link\u2019 function and paste your credential\u2019s URL into it. The URL is the web address for your digital credential.\n\n4. Don\u2019t forget to hit save on any changes you make to your email signature.",
        },
        {
          q: "How Do I Send an Email Direct from the Credential View?",
          a: "You don\u2019t need to copy and paste information across from the Credential View to a separate email. Send an email directly from the Credential View for easy sharing.\n\nSend the Credential in an Email\n\n1. Head to the Credential View of the badge or certificate you would like to share in an email.\n2. Click on the \u2018Email\u2019 button along the bottom of the credential window.\n3. Fill in your email address and the email address of the person you want to share the credential with.\n4. Fill out the ReCaptcha \u2018I\u2019m not a robot\u2019 check.\n5. Click \u2018Send\u2019 to share your credential with that all-important person.\n\nThe Finished Email\n\nYour recipient will receive an email that looks similar to the message pictured below:\n\nThe \u2018View it now\u2019 button will take your recipient straight to your credential view to verify the achievement and see more information regarding your award.",
        },
        {
          q: "How Do I Share My Credential?",
          a: "One of the brilliant benefits of a digital credential is that it is easily shared. Let friends, customers, and prospective employers alike know what you\u2019ve achieved.\n\nSharing the URL\n\nThe Unique URL is the most valuable way you have of sharing your credential. You can place your credential\u2019s unique URL in a large variety of places.\n\nSocial Media\n\nWe have widgets for all the major social media channels right there on your credential view, including Facebook, Twitter, and Pinterest. Click on a button to post to that particular platform.\n\nCheck out our How to Use Your New Digital Credential video for more information",
        },
        {
          q: "How Do I Add My Credential to LinkedIn?",
          a: "You\u2019ve acquired your credential. Now it\u2019s time to show it off. Make sure to add your certificate or badge to LinkedIn so that everyone can see it!\n\nIf The LinkedIn Options are Hidden\n\nIf the options mentioned in the article below are hidden, you will need to sign in to your credential to use them.\n\nTwo Ways of Adding Your Credential to LinkedIn\n\nShare to LinkedIn\n\nCreate a post about your credential that will appear to your connections in your LinkedIn Newsfeed.\n\n1. Click on the LinkedIn \u2018Share\u2019 button at the bottom of the credential window. If you are not already logged in to your LinkedIn account, you will be prompted to do so.\n2. You will then be taken to LinkedIn\u2019s site, where you can choose to share as a post or as a private message.\n3. Write a message to accompany your certificate in your post or message and click Post/Send.\n\nYou will then have a lovely big statement about your achievement that is visible to all your connections. Do bear in mind, though, that this will drop through the newsfeed and become less visible as time goes by.\n\nAdd to LinkedIn Profile\n\n1. To add your credential to your LinkedIn profile, you will need to be signed in to your credential.\n2. When signed in to your credential, you will see that the \u2018Verify\u2019 button on your credential view is replaced with an \u2018Add to LinkedIn Profile\u2019 button. Click this button.\n\n3. A pop-up will appear to confirm how you would like to share your credential. Select \u2018Add to my profile.\u2019\n\n4. Your credential information will be automatically carried over to the \u2018License and Certification\u2019 form in LinkedIn. Click \u2018Save.\u2019\n\n5. Your credential will then appear on your LinkedIn profile for as long as you would like it to be there, and anyone that clicks on the link will be taken straight to your credential view, where it can be verified.\n\nGood to Know: The Thumbnail for your credential on your LinkedIn profile will be your issuer\u2019s logo, not your credential. The LinkedIn platform determines this behavior.",
        },
        {
          q: "How Do I Add Evidence To My Credential?",
          a: "Identify what makes your achievement unique to you. Add evidence items that show how you won your achievement.\n\nWhat Can I Use as an Evidence Item?\n\nThere are many types of evidence items you can add to your certificate or badge. A few suggestions would be:\n\n\u2022 Assignments and work you\u2019ve completed\n\u2022 A video summarising what you\u2019ve learned\n\u2022 Links to projects and work you\u2019ve been involved with\n\u2022 References from colleagues\n\nHow to Add an Evidence Item\n\n1. Navigate to the credential you would like to add evidence to.\n2. Scroll to the bottom of the Credential View. Click the \u2018Add an Evidence Item\u2019 option.\n   \u2022 Use the \u2018choose file\u2019 upload option to upload a document from your computer, or in the pop-up window that appears, enter the evidence you would like to use:\n   \u2022 If your evidence item is hosted on the internet, such as on a web page as a Youtube video, enter the URL into the \u2018Or from a link\u2026\u2019 section.\n4. Give your evidence a title in the \u2018Evidence Description\u2019 field.\n5. Click \u2018Save\u2019 to add your evidence to your credential view.",
        },
        {
          q: "May I get a hardcopy of my Diploma/ Certificate",
          a: "A hardcopy of your Diploma/Certificate is available upon request, please contact Anderson College by following the next steps:\n\n1. Navigate to your digital credential.\n2. Click on the \u2018More\u2019 button under the credential window.\n3. In the pop-up menu, click on \u2018Contact Issuer.\u2019\n4. An email window will appear with the correct contact email address already filled in, complete the message you want to send to Anderson College, and hit \u2018Send.\u2019",
        },
      ],
    },
    {
      heading: "Changing Your Credential",
      items: [
        // Source: staging /digital-credentials-frequently-asked-questions/
        // Verbatim restore. Last verified 2026-04-25.
        {
          q: "Why Is My Name Change Not Reflected on the PDF Download of My Credential?",
          a: "If your name change request has been approved but is not reflected on the PDF of your credential, here is what to do.\n\nWhy Is This Happening?\n\nThis problem is being caused by the internet\u2019s browser\u2019s cache. When you click \u2018Download PDF\u2019 your browser is choosing to re-download the version of the PDF that it saved in its cache before changes to the certificate were made, instead of properly downloading the new version of the certificate.\n\nHow Do I Fix It?\n\nYou will need to go to your internet browser\u2019s settings and empty it\u2019s image and PDF cache. When you next download the PDF, it will appear correctly.\n\nThe instructions on how to do this for various internet browsers can be found below:\n\nChrome\n\n1. On your computer, open Chrome.\n2. At the top-right, click More.\n3. Click More tools. Clear browsing data.\n4. At the top, choose a time range. To delete everything, select All time.\n5. Next to \u2018Cookies and other site data\u2019 and \u2018Cached images and files\u2019, tick the boxes.\n6. Click Clear data.\n\nFirefox\n\n1. In the Menu bar at the top of the screen, click Firefox and select Preferences. ...\n2. Select the Privacy & Security panel.\n3. In the Cookies and Site Data section, click Clear Data\u2026.\n4. Remove the check mark in front of Cookies and Site Data. ...\n5. With Cached Web Content check marked, click the Clear button.\n6. Close the about:preferences page. Any changes you\u2019ve made will automatically be saved.\n\nMicrosoft Edge\n\n1. Open Microsoft Edge, select Menu (3 dots icon on top right corner of the browser) > Settings > Privacy & services.\n2. Under Clear browsing data, select Choose what to clear.\n3. Select \u2018Cached images and files\u2019 and \u2018Cookies and other site data\u2019 check box and then select Clear.\n\nSafari\n\n1. Open a new browser window.\n2. Choose Safari.\n3. Click \u2018Clear History\u2019.\n4. Choose the drop-down menu.\n5. Select \u2018all history\u2019.\n6. Click \u2018Clear History\u2019.\n\nIMPORTANT NOTE: In some rare instances, it can take up to 24-48 hours for the change to be reflected on the PDF. If the issue persists after clearing your cache, and 24-48 hours has passed, please contact support@accredible.com.",
        },
        {
          q: "How Do I Request a Name Change?",
          a: "If there is a typo in your name, the wrong name has been used, or you need part of your name added/removed, you will need to submit a name change request.\n\nHow to Request a Name Change\n\n1. Sign in to your credential.\n2. Along the bottom of the credential window, click the \u2018MORE\u2019 button.\n3. In the pop-up menu, select the \u2018Request a Name Change\u2019 option.\n4. Please enter the name as you would like it to appear in both fields.\n5. Click \u2018Request.\u2019",
        },
        {
          q: "How Do I Make My Credential Private/Public?",
          a: "Anderson College will publish your credential as public by default. If you would like to change the visibility of your credential, here\u2019s how.\n\nSign In to Your Credential\n\nThe option to change the visibility of your credential is not publicly available. You will need to prove you are the credential owner before you can make this change.\n\nChanging the Privacy Setting\n\n1. Sign in to your credential as described in the article mentioned above.\n2. Along the bottom of the credential window, click the \u2018Privacy\u2019 button.\n3. A pop-up window will emerge asking you to set the visibility of your credential:\n   1. Switch the toggle button off to make your credential private (the toggle button will turn grey).\n   2. Switch the toggle button on to make your credential public (the toggle button will turn green).\n4. Click on \u2018Update privacy\u2019 to apply any changes.\n\nImportant Note: You can always change the privacy of your credential. As its owner, you are always in control.\n\nWhen a Credential is Private\n\nThe credential is:\n\n\u2022 Visible only to you\n\u2022 Links on social media will not work\n\u2022 Will be hidden from search engine results\n\nWhen a Credential is Public\n\nThe credential is:\n\n\u2022 Visible to anyone with the link\n\u2022 It can be shared on social media\n\u2022 Will be visible in search engine results",
        },
        {
          q: "How Do I Change the Email Address Attached to My Certificate?",
          a: "The email address that is attached to your credential is important. If you want to get it changed you will need to contact Anderson College support team.\n\nWhich Email Address is My Credential Attached To?\n\nYour credential will be attached to the email address your credential was sent to.\n\nWhat if I Have Linked Email Addresses in My Credential Wallet?\n\nIf you have used the \u2018Linked Email\u2019 function in your credential wallet settings, this does not update the email address attached to your credentials. By linking emails in a credential wallet, you ask the system to show credentials belonging to two different email addresses in the same wallet.\n\nHow Do I Update the Email Address Attached to My Credential?\n\nThe only way to update the email address attached to your credential is to send us a request. For security and fraud reasons, Anderson College must verify that it is, in fact, you, the owner of the credential, who is making the request.\n\nTo contact us, use the \u2018Contact Issuer\u2019 option on your credential view.",
        },
      ],
    },
  ],
};


// OPSWA — verbatim from staging /opswa-membership/.
export const OPSWA = {
  hero: {
    eyebrow: "Student Life",
    title: "Complimentary OPSWA Membership For Anderson Students",
    subtitle:
      "Every Personal Support Worker (PSW) student at Anderson College receives a complimentary student membership with the Ontario Personal Support Worker Association (OPSWA) \u2014 the professional voice for PSWs across Ontario.",
    image: "/assets/heroes/opswa-hero.webp",
  },
  logo: "/assets/affiliations/opswa-logo.jpg",
  intro: [
    "At Anderson College, your education is only the beginning of your professional journey. That\u2019s why every Personal Support Worker (PSW) student receives a complimentary student membership with the Ontario Personal Support Worker Association (OPSWA) \u2014 the professional voice for PSWs across Ontario. Anderson College has partnered with the Ontario PSW Association to give every PSW student professional support from the start. This collaboration places students front and center and reflects a strong commitment to professionalism in PSW education.",
    "Through this partnership, students gain access to industry resources, professional standards, career guidance, and an official co-branded student ID. Created by PSWs to support and advocate for the profession, OPSWA provides education, professional development opportunities, and a strong voice in government policy. As a student member, you\u2019ll also receive discounts on courses, workshops, and training designed to help you build confidence, enhance your skills, and stand out to employers from your first weeks in the program.",
  ],
  videoId: "5uhYrq_1ZfY",
  videoTitle: "OPSWA Partnership: A Game-Changer for Anderson PSW Students",
  faqs: [
    {
      q: "What Is OPSWA?",
      a: "The Ontario PSW Association (OPSWA) is the professional association that supports and advocates for Personal Support Workers across Ontario.\n\nOPSWA provides:\n\u2022 Professional standards and guidance\n\u2022 Education and training resources\n\u2022 Career support and industry information\n\u2022 Advocacy with government and healthcare leaders\n\nOPSWA exists to support, represent, and advocate for PSWs through education, resources, and professional standards.",
    },
    {
      q: "What You Get as an Anderson Student Member",
      a: "As an Anderson College PSW student, you automatically receive:\n\u2022 OPSWA/Anderson student ID badge\n\u2022 Members-only access to resources\n\u2022 50% off OPSWA courses, workshops, and events\n\u2022 Access to discount partners and benefits\n\u2022 Discounted full membership after graduation\n\nStudents also gain access to professional development courses, community support, and industry resources.",
    },
    {
      q: "How the Complimentary Membership Works",
      a: "\u2022 You are automatically enrolled as a student member. Enrollment is handled directly by the college, and students typically receive access within the first month of their program.\n\u2022 No separate application is required.\n\u2022 Your membership remains active for the duration of your PSW program.",
    },
    {
      q: "Why join OPSWA as a student?",
      a: "Joining OPSWA as a student helps you:\n\u2022 Build professional credibility\n\u2022 Learn industry standards\n\u2022 Access mentorship and guidance\n\u2022 Prepare for employment\n\u2022 Transition smoothly into your PSW career\n\nStudent membership is designed to help you prepare for employment and professional practice after graduation.",
    },
    {
      q: "Can I access OPSWA support as a student?",
      a: "As a student member, you can contact OPSWA for:\n\u2022 Membership questions\n\u2022 Documentation support\n\u2022 Professional standards guidance\n\u2022 General career advice\n\nOPSWA also offers job postings, career resources, and professional guidance, though employment is not guaranteed.\n\nAfter graduation, you can upgrade to a full OPSWA membership at a discounted rate for your first year.",
    },
    {
      q: "Can I work as a PSW with a Student Membership?",
      a: "Student membership does not replace employer hiring requirements.\n\nTo work as a PSW, you must meet your employer\u2019s conditions, which usually include graduation, police checks, and onboarding.\n\nAlways confirm with your employer.",
    },
    {
      q: "Can my membership be suspended?",
      a: "Yes. Membership may be suspended for:\n\u2022 Breaches of the Code of Conduct\n\u2022 False information\n\u2022 Serious complaints\n\u2022 Policy violations\n\nAll matters are reviewed fairly.",
    },
    {
      q: "Who do I contact for help?",
      a: "OPSWA Membership Support\n\nEmail: memberships@opswa.com\nWebsite: www.opswa.com\n\nFor academic questions, contact Anderson College directly.",
    },
    {
      q: "Important Notes",
      a: "\u2022 Student membership is valid only during your program.\n\u2022 It does not replace employer hiring requirements.\n\u2022 You must upgrade to full membership after graduation to continue benefits.",
    },
  ],
};

// ODAA — verbatim from staging /complimentary-odaa-membership-for-anderson-students/.
export const ODAA = {
  hero: {
    eyebrow: "Student Life",
    title: "Complimentary ODAA Membership For Anderson Students",
    subtitle:
      "Becoming a student member of the Ontario Dental Assistants Association (ODAA) is one of the most valuable steps an aspiring dental assistant can take to build a strong professional foundation.",
    image: "/assets/heroes/odaa-hero.webp",
  },
  logo: "/assets/migrated/odaa-logo2.png",
  intro: [
    "Becoming a student member of the Ontario Dental Assistants Association (ODAA) is one of the most valuable steps an aspiring dental assistant can take to build a strong professional foundation. As the recognized professional association supporting dental assistants across Ontario, the ODAA connects students to the standards, ethics, advocacy, and community that shape excellence in the field.",
    "Through student membership, dental assistant students gain access to professional resources, industry updates, networking opportunities, and a broader understanding of their role within the dental healthcare team. It\u2019s an early introduction to the expectations and opportunities that define a successful career \u2014 helping students transition confidently from the classroom to the clinic.",
    "At Anderson College, this advantage goes even further. Every Dental Assistant student receives a complimentary ODAA student membership as part of their program experience. This meaningful value-added benefit reflects Anderson College\u2019s commitment to enhancing the student journey and preparing graduates for real-world success.",
    "By integrating professional association membership directly into the program, Anderson College ensures students graduate not only with practical skills and knowledge, but also with professional credibility, confidence, and connections. It\u2019s an investment in student success that continues to deliver value long after graduation.",
  ],
  benefitsHeading: "Key Benefits for Students",
  faqs: [
    {
      q: "1. Early Professional Identity and Status",
      a: "Dental assisting is a profession, and being part of a professional organization is a recognized marker of status, commitment, and credibility. ODAA membership signals that students take their role seriously and are aligned with the ethical and practice standards of Ontario\u2019s dental assisting community.",
    },
    {
      q: "2. Access to Trusted, Up-to-Date Information",
      a: "Members receive reliable, current information on:\n\u2022 Scope of practice\n\u2022 Regulatory updates from the Royal College of Dental Surgeons of Ontario (rcdso.org)\n\u2022 Infection prevention and control standards\n\u2022 Best practices in clinical and administrative assisting\n\nThis ensures students graduate with not only strong technical skills but also a clear understanding of the professional environment they are entering.",
    },
    {
      q: "3. Networking and Mentorship",
      a: "Membership provides access to a province-wide network of experienced dental assistants, educators, and employers. Students gain:\n\u2022 Real-world insights\n\u2022 Mentorship opportunities\n\u2022 Access to events that support career growth\n\u2022 Access to the ODAA member forum\n\nThese connections often lead to employment opportunities and long-term professional relationships.",
    },
    {
      q: "4. Career Development and Employment Support",
      a: "The ODAA offers tools that help students transition confidently into the workforce, including:\n\u2022 Job boards and employment resources\n\u2022 Complimentary employment webinars\n\u2022 Professional development opportunities\n\nThis gives Anderson College students a competitive edge as they prepare to enter the field.",
    },
    {
      q: "5. Continuing Education and Skill Advancement",
      a: "Members have access to high-quality, low-cost, and free continuing education that supports lifelong learning. Students can begin building their professional development portfolio even before graduation. Membership also provides the opportunity to earn credentials and professional designations.",
    },
    {
      q: "6. Advocacy and Representation",
      a: "The ODAA is the voice of dental assistants in Ontario. By joining, students contribute to:\n\u2022 Strengthening the profession\n\u2022 Supporting advocacy efforts\n\u2022 Ensuring dental assistants have representation in provincial discussions\n\nIt\u2019s an opportunity to be part of shaping the future of the profession.",
    },
    {
      q: "Why This Matters at Anderson College",
      a: "Anderson College\u2019s decision to provide complimentary ODAA student memberships demonstrates a commitment to elevating the student experience and ensuring graduates enter the workforce with credibility, confidence, and professional connections. This meaningful value-added benefit supports student success long after graduation and reinforces that dental assisting is a respected profession \u2014 one in which belonging to a professional association is a mark of status and pride.",
    },
  ],
};

// ──────────────── Financial Aid sub-pages (verbatim from staging) ────────────────
// Sources: /better-jobs-ontario/, /alumni-bursary/,
// /empower-ukrainians-in-canada/, /windmill-microlending/, /new-to-canada/,
// /student-lines-of-credit/, /out-of-province-students/, /cardiology-technologist-bursary/.
// Last verified 2026-04-25.

const CLOSING_NAVIGATE = {
  heading: "Want Help Navigating All the Options?",
  body:
    "No need to do it alone.\n\nContact a member of our Admissions team and we\u2019ll work with you to match your interests and goals to a program and walk you through the steps that lead to start-day and career success.",
  cta: { label: "Connect Now" },
};

// post-55
export const BETTER_JOBS_ONTARIO = {
  hero: {
    eyebrow: "Financial Aid",
    title: "Better Jobs Ontario",
    subtitle:
      "Education is one of the most important investments in life. \u201CCan I afford it?\u201D is a question frequently asked by our students, especially if they\u2019ve been laid off or are looking to create a career path that will provide greater security for the future.",
    image: "/assets/heroes/better-jobs-ontario-hero.jpg",
    mobileImage: "/assets/heroes/better-jobs-ontario-hero-mobile.png",
  },
  sections: [
    {
      heading: "WHAT IS BETTER JOBS ONTARIO FUNDING?",
      body:
        "Better Jobs Ontario Funding is an education funding available for recently laid-off unemployed workers. For many, long-term skills training is essential in the transition to in-demand career opportunities, and our practical programs and real-life training, delivered by high-calibre, industry-expert faculty, can take you there. You just need funding options to get you back to school and work. If you are a recently laid-off unemployed worker, an active EI claimant or EI reachback, you may be able to access this funding.\n\nBased on your eligibility, Anderson College can assist you as you:",
      bullets: [
        "Train for a new career",
        "Find out what is needed in the job market",
        "Learn about careers that build on your skills",
        "Apply for second career funding",
      ],
    },
    {
      heading: "HOW CAN IT HELP YOU?",
      body:
        "The Better Jobs Ontario Funding empowers you to receive the education and training necessary to become skilled, confident and in-demand in the marketplace. It provides funding to pay for tuition and supporting expenses such as:",
      bullets: [
        "Books",
        "Living expenses",
        "Help caring for dependents",
        "Travel & transportation",
        "Disability supports",
        "Other living and training costs",
      ],
    },
    {
      heading: "HOW DOES IT WORK?",
      body:
        "Better Jobs Ontario Funding starts with a visit to a Better Jobs Ontario Admissions Advisor at an employment assessment centre. They will work with you to help you prepare a training plan and apply for Second Career funding.",
    },
    {
      heading: "WHAT WILL THE ADMISSIONS ADVISOR NEED TO KNOW?",
      body: "Your Admissions Advisor will need to know about:",
      bullets: ["Your work history", "Your education and training", "Your skills", "Your interests"],
    },
    {
      heading: "WHAT SHOULD I DO NOW?",
      body:
        "Contact an employment assessment centre to get it started. Or contact us now so we can guide you toward your next steps.",
    },
  ],
  closing: CLOSING_NAVIGATE,
};

// post-57
// ─── FALL_BURSARY — Program-Centric Graduation Bursaries (2026) ─────────────
// Wired to /financial-aid/fall-bursary and to the sticky CTA on each
// eligible program page. Turning the bursary on/off for a program is a
// one-line edit here — no code changes.
export const FALL_BURSARY = {
  window: {
    startDate: "2026-09-01",
    endDate: "2026-10-31",
    label: "Sept 1 - Oct 31, 2026",
  },
  hero: {
    eyebrow: "Financial Aid",
    title: "Kickstart Fall 2026 with a Graduation Bursary of up to $3,000",
    image: "/assets/heroes/alumni-bursary-hero.png",
    mobileImage: "/assets/heroes/alumni-bursary-hero-mobile.png",
    lightOverlay: true,
  },
  intro:
    "Start any qualifying program between Sept 1 and Oct 31, 2026 and receive your bursary when you graduate. Speak to an Advisor to find out how.",
  programs: [
    { slug: "accounting-and-payroll-administration",  name: "Accounting & Payroll Administration",      amount: 1885 },
    { slug: "business-administration",               name: "Business Administration",                  amount: 1885 },
    { slug: "early-childcare-assistant",             name: "Early Childcare Assistant",                amount: 1885 },
    { slug: "early-childhood-education",             name: "Early Childhood Education",                amount: 2885 },
    { slug: "medical-office-administrator",          name: "Medical Office Administrator (In-Campus)", amount: 1000 },
    { slug: "paralegal",                             name: "Paralegal",                                amount: 2500 },
    { slug: "law-enforcement-police-foundations",    name: "Law Enforcement & Police Foundations",     amount: 1885 },
    { slug: "cardiology-technologist",               name: "Cardiology Technologist",                  amount: 3000 },
    { slug: "medical-esthetician",                   name: "Medical Esthetician",                      amount: 1885 },
  ],
  sections: [
    {
      heading: "How the Fall 2026 Bursary Works",
      body:
        "Start any qualifying program between Sept 1 and Oct 31, 2026 and receive your bursary when you graduate. Speak to an Advisor to find out how.",
    },
    {
      heading: "Ready to Enrol?",
      body:
        "Speak with an Admissions Advisor to lock in your seat, confirm your start date, and get the bursary applied to your tuition. Advisors are available Monday to Friday, 9 AM - 5 PM ET.",
    },
  ],
  note:
    "*The Fall 2026 Graduation Bursary is available to students who enrol AND start their qualifying program between September 1, 2026 and October 31, 2026. Bursary amount is program-specific (see list above). The bursary is pro-rated if the student withdraws. Cannot be combined with other Anderson College bursaries or scholarships. Conditions apply.",
  closing: CLOSING_NAVIGATE,
};


export const ALUMNI_BURSARY = {
  hero: {
    eyebrow: "Financial Aid",
    title: "Elevate Your Journey with Anderson College: Exclusive Alumni Bursary Awaits!*",
    image: "/assets/heroes/alumni-bursary-hero.png",
    mobileImage: "/assets/heroes/alumni-bursary-hero-mobile.png",
    lightOverlay: true,
  },
  intro:
    "Congratulations on your remarkable achievement of completing the program at Anderson College! As a testament to your dedication and success, we are excited to extend a heartfelt congratulations and present you with an exclusive opportunity.",
  sections: [
    {
      heading: "Unlock Your Potential with the Alumni Bursary*",
      body:
        "In recognition of your accomplishments, we\u2019re offering a special Alumni Bursary* designed to empower you in taking the next steps on your career path. As a token of our appreciation, we\u2019re excited to announce an additional opportunity exclusively for our valued alumni. Enroll now for your second program, and you could receive a bursary of up to $1000! This bursary is our way of expressing gratitude for your commitment and dedication to excellence.",
    },
    {
      heading: "\u201CIt all Started with a visit to Anderson College ....!\u201D",
      body:
        "Thank you for being an integral part of our vibrant alumni community. We look forward to witnessing your continued success and supporting you in your educational endeavors!\n\nApply for the bursary, and our Admissions team will guide you through all the details.",
    },
  ],
  note:
    "*The Alumni Bursary cannot be applied to programs with tuition fees less than $6,000. The bursary is pro-rated if the student withdraws. Conditions apply.",
  closing: CLOSING_NAVIGATE,
};

// post-61
export const EMPOWER_UKRAINIANS = {
  hero: {
    eyebrow: "Financial Aid",
    title: "\u201CEmpower Ukrainians in Canada\u201D Campaign",
    subtitle: "20% to 50% study scholarships available to Ukrainians with a CUAET*",
    image: "/assets/heroes/empower-ukrainians-hero.jpg",
  },
  intro: [
    "Anderson College of Health, Business and Technology announces the launch of its \u201CEmpower Ukrainians in Canada\u201D campaign. This signifies its commitment to support Ukrainian newcomers and includes a 20% or a 50% scholarship* for a fast-track, career-training program, free English as a Second Language (ESL) classes, and complimentary, confidential mental health and emotional support, in Ukrainian, via a 24-hour hotline.",
    "We understand how incredibly challenging this time has been for Ukrainians coming to Canada as they flee violence in their home country, and although they\u2019ve found a safe haven in Canada for a time, we know that finding their way in a new country can be overwhelming.",
    "We are truly here to help.",
    "Our \u201CEmpower Ukrainians in Canada\u201D campaign has been designed to offer the practical resources and support Ukrainians need during their Canadian stay.",
  ],
  includesHeading: "This includes:",
  includes: [
    {
      title: "Financial Aid Availability",
      body:
        "A 20% or 50% scholarship (one per student), for tuition fees*, and an opportunity to apply for additional aid via Windmill Microlending program.",
    },
    { title: "Free English Language Classes" },
    {
      title: "23 Fast-Track Career Training Programs",
      body:
        "To choose from, in healthcare, business and technology that feature small class sizes, expert instructors, on-the-job-training with potential employers and career services support.",
    },
    {
      title: "Flexible Schedules",
      body:
        "To ensure students can balance their time with family, work to support themselves and their loved ones, all while they study to upgrade their skills for Canada or launch a new, rewarding career.",
    },
    {
      title: "Caring, Supportive Community and Health Hotline",
      body:
        "Perhaps most important of all, we at Anderson are committed to both personal and professional success. We know the two go hand in hand. Our whole team, from our admissions team and instructors to our executive and administration staff, is here, every step of the way. This includes our 24 hour/365 keep.meSAFE mental and emotional health support hotline, offered in Ukrainian.",
    },
  ],
  outro:
    "Ukraine has inspired the world with its courage, and we are grateful to have the opportunity to support Ukrainians during their time here in Canada. Whether they are upgrading their skills to work in Canada or looking to find a new and rewarding career to support themselves and their families, we\u2019ve got a solution. And it\u2019s all within a community that is committed to ensuring they feel, and know, we appreciate having them here with us.\n\nKnow anyone who would be interested in starting a program and launching a new career? Join our referral program and be rewarded!",
  fiftyPercent: [
    "Executive Administration",
    "Paralegal",
    "Health Information Management",
    "Business Administration",
    "Child & Youth Care with Addictions Support Worker",
    "Accounting & Payroll Administration",
    "Developmental Service Worker",
    "Paralegal Studies",
    "Early Childcare Assistant",
    "Medical Office Administrator",
    "Information Technology (IT) Technician",
    "Medical Office Administration",
    "Office/Small Business Administration",
    "Occupational Health and Safety",
    "Advanced Diploma in Cisco and Red Hat System Administration",
    "Law Enforcement / Police Foundations",
    "Supply Chain and Logistics",
    "Business Accounting & Payroll",
    "Law, Security and Police Foundations",
    "Law Clerk",
    "Business Management",
  ],
  twentyPercent: [
    "Intra Oral Level I & II Dental Assistant",
    "Massage Therapy",
    "Medical Laboratory Technician",
    "Esthetics",
    "Medical Laboratory Technician Assistant",
    "Orthopaedic Technician",
    "Personal Support Worker (PSW)",
    "Medical Esthetician",
    "Personal Support Worker",
    "Intra-Oral Dental Assistant Levels I & II",
    "Pharmacy Assistant",
    "Personal Support Worker Certificate",
    "Film and Video Production \u2013 Storytelling for the Digital Age",
    "Pharmacy Technician",
    "Physiotherapist & Occupational Therapist Assistant",
    "Personal Support Worker \u2013 Hybrid",
  ],
  notes: [
    "*CUAET \u2013 Canadian-Ukrainian Authorization for Emergency Travel. Students are solely responsible for ensuring that they are in compliance with all Immigration, Refugees and Citizenship Canada regulations at all times during their studies and while in Canada, including any medical or study and work permit-related requirements. The information on this page does not constitute any legal advice and information may change without notice. Always refer to Immigration, Refugees and Citizenship Canada (IRCC) (www.cic.gc.ca) website for the most up-to-date information.",
    "**This is a limited-time offer. To apply for the scholarship, applicants must confirm their CUAET status. In order to confirm CUAET status, applicants will have to submit their Study Permit or any other document indicating their CUAET status. Their CUAET designation must be noted on the submitted document.",
    "***The scholarship is pro-rated if the student withdraws. Anderson College can withdraw or extend the offer at any point in time. This offer cannot be combined with other bursary offers. Other conditions may apply.",
  ],
  closing: CLOSING_NAVIGATE,
};

// post-63
export const WINDMILL_MICROLENDING = {
  hero: {
    eyebrow: "Financial Aid",
    title: "Windmill Microlending",
    subtitle:
      "Anderson College partners with Windmill Microlending to provide financial support to skilled newcomers for their education. Windmill Microlending can help unleash your full potential. A low-interest loan can help you achieve career success in your dream role.",
    image: "/assets/heroes/windmill-microlending-hero.png",
    mobileImage: "/assets/heroes/windmill-microlending-hero-mobile.png",
  },
  intro: {
    heading: "Are You A Newcomer and Looking to Launch your Career in Canada? Additional Funding to Study with Anderson is Available!",
    body:
      "Windmill Microlending is a registered charity serving newcomers since 2005. Windmill Microlending provides loans of up to $15,000 for skilled immigrants and refugees to pay for their Canadian licensing or training needed to restart or continue their careers in Canada. Loans can be used to cover fees for licensing and qualifying exams, credential assessments, books, course materials, living allowance during the study period, and language courses.",
    eligibilityLink: {
      label: "click here",
      href:
        "https://event.windmillmicrolending.org/?RR_WCID=4233BA8C-A2CA-46D6-8140-B7527C4D1A35&RR_WCID_TTL=396&REFERRALCODE=ANDERSON&utm_campaign=Need+a+loan+Active#personal-details",
    },
    foundersLink: { label: "Click here", href: "https://www.youtube.com/watch?v=gtRHkiet8bA&t=9s" },
  },
  paysFor: {
    heading: "The loans can pay for:",
    items: [
      "Education and training programs of two years or less",
      "Fees for licensing and qualifying exams",
      "Fees for professional associations",
      "Books, supplies and other course materials",
      "Travel expenses to take courses or write exams which are unavailable in your area",
      "Assessment of qualifications",
      "Living allowance during study time",
      "Potentially, other costs related to restarting your career",
    ],
  },
  eligibility: {
    heading: "Are You Eligible for the Funding Support?",
    intro: "To be eligible for a Windmill microloan, you must:",
    items: [
      "Be an immigrant and a Permanent Resident, Protected Person, Convention Refugee, Provincial Nominee, or Canadian Citizen",
      "You must be living in Canada to apply for a loan",
      "Be an internationally-trained individual requiring licensing, re-training, or relocation to achieve your career goals",
      "Not have an undischarged bankruptcy",
    ],
  },
  closing: CLOSING_NAVIGATE,
};

// post-65
export const NEW_TO_CANADA = {
  hero: {
    eyebrow: "Financial Aid",
    title: "For Students New to Canada",
    subtitle:
      "We know first-hand how stressful and frightening it can be to establish a career in a new country. Connect with us to review the options available for new Canadians.",
    image: "/assets/heroes/new-to-canada-hero.png",
    mobileImage: "/assets/heroes/new-to-canada-hero-mobile.png",
  },
  partner: {
    heading: "ANDERSON IS A PARTNER TO NEW CANADIANS",
    paragraphs: [
      "For over 140 years, Anderson College has been a partner to thousands of students who have overcome career challenges and transitioned to the next phase of their lives. Our environment of comradery and community provides a much-needed respite from the stresses of starting over.",
      "Our students come to us from all corners of the globe and each has a unique story to tell. We celebrate their individuality and support them as they strive to overcome challenges and create a better life for themselves and their families. Within our community, we build a culture of equality and care.",
      "Our high-calibre faculty, comprised of industry experts, deliver practical programs and real-life career training, which enables graduates to become skillful, confident and in-demand employees.",
      "Let us be a partner to you as you build a new life in Canada \u2026",
    ],
  },
  support: {
    heading: "YOU HAVE WHAT IT TAKES; WE HAVE THE SUPPORT",
    intro:
      "Anderson College is dedicated to helping you achieve your educational and career goals. Our focus is to empower you to become a skilled, confident and in-demand employee. We understand how challenging it can be to re-establish yourself in a new country, but we have resources and a team ready to help you all along the way. Contact us now to see how you can receive:",
    items: [
      {
        title: "Career Services Assistance",
        body:
          "Our students and alumni can access the Career Services Department for assistance with resume writing and job search techniques",
      },
      {
        title: "Canadian Work Experience",
        body: "Most of our programs include practicum \u2013 Our students graduate with Canadian work experience",
      },
      {
        title: "Canadian Education",
        body: "Anderson College Programs are recognized by the Ministry and various industry associations",
      },
      {
        title: "Variety of Funding Options",
        body: "Financial assistance may be available to those who qualify",
      },
    ],
  },
  consultation: {
    heading: "FREE CONSULTATION FOR NEWCOMERS",
    body:
      "Imagine yourself in a new career and building a community of support in Canada, but not sure where to start? Thinking of studying but don\u2019t know which program matches your skillset and your goals? Wanting to start but not sure if you can afford an education? Not a problem. There is no need to navigate all the information alone. Anderson College will guide you through this process. We provide:",
    items: [
      "FREE Career Evaluation",
      "FREE Financial-aid Assessment & Estimate",
      "FREE Trial Class",
      "FREE Consultation on program offerings and what is the best fit for you.",
    ],
  },
  referral: {
    heading: "SPREAD THE WORD AND BE REWARDED",
    body:
      "If you know of someone who will benefit from the Newcomer Bursary and you refer them to Anderson College, you\u2019ll be rewarded! We know that referrals are golden and so, just for spreading the word you may be eligible to receive a minimum of $300 per referral.",
  },
  closing: CLOSING_NAVIGATE,
};

// post-67
export const STUDENT_LINES_OF_CREDIT = {
  hero: {
    eyebrow: "Financial Aid",
    title: "Lines of Credit for Students",
    subtitle:
      "Education is one of the most important investments in life. \u201CCan I afford it?\u201D is a question frequently asked by our students. Let us help you navigate the funding options.",
    image: "/assets/heroes/student-lines-of-credit-hero.png",
    mobileImage: "/assets/heroes/student-lines-of-credit-hero-mobile.png",
  },
  sectionHeading: "Major Canadian Banks Offering Student Lines of Credit",
  banks: [
    {
      name: "Bank of Montreal",
      product: "Student Line of Credit",
      site: { label: "www.bmo.com", href: "https://www.bmo.com/en-ca/main/personal/loans-line-of-credit/student-borrowing/student-line-of-credit/" },
      phone: { label: "1-877-CALL-BMO", href: "tel:18772255266" },
    },
    {
      name: "CIBC",
      product: "Education Line of Credit",
      site: { label: "www.cibc.com", href: "https://www.cibc.com/en/student/student-lines-of-credit/education-line-of-credit.html" },
      phone: { label: "1-800-465-2422", href: "tel:18004652422" },
    },
    {
      name: "Royal Bank",
      product: "Student Line of Credit",
      site: { label: "www.rbcroyalbank.com", href: "https://www.rbcroyalbank.com/personal-loans/student-line-of-credit.html" },
      phone: { label: "1-877-769-2511", href: "tel:18007692511" },
    },
    {
      name: "Scotiabank",
      product: "Personal Line of Credit for Students",
      site: { label: "www.scotiabank.com", href: "https://www.scotiabank.com/ca/en/personal/loans-lines/line-of-credit/scotialine-personal-line-of-credit-students.html" },
      phone: { label: "1-800-4SCOTIA", href: "tel:18004726842" },
    },
    {
      name: "TD Bank",
      product: "Student Line of Credit",
      site: { label: "www.td.com", href: "https://www.td.com/ca/en/personal-banking/products/borrowing/lines-of-credit/student-line-of-credit/" },
      phone: { label: "1-877-225-5266", href: "tel:18772255266" },
    },
  ],
  closing: CLOSING_NAVIGATE,
};

// post-71
export const OUT_OF_PROVINCE = {
  hero: {
    eyebrow: "Financial Aid",
    title: "For Students From Out of Province",
    subtitle:
      "Are you from out-of-province and looking to attend Anderson College? Financial assistance may be available to those who qualify.",
    image: "/assets/heroes/out-of-province-students-hero.png",
    mobileImage: "/assets/heroes/out-of-province-students-hero-mobile.png",
  },
  sectionHeading: "Financial Aid by Province",
  provinces: [
    {
      name: "Alberta",
      product: "Student Aid Alberta",
      site: { label: "studentaid.alberta.ca", href: "https://studentaid.alberta.ca/" },
      phone: { label: "1-855-606-2096", href: "tel:18556062096", note: "(toll-free in North America)" },
    },
    {
      name: "British Columbia",
      product: "Student Aid BC",
      site: { label: "studentaidbc.ca", href: "https://studentaidbc.ca/" },
      phone: { label: "1-800-561-1818", href: "tel:18005611818", note: "(toll-free in North America)" },
    },
    {
      name: "Manitoba",
      product: "Manitoba Student Aid",
      site: { label: "www.edu.gov.mb.ca", href: "https://www.edu.gov.mb.ca/msa/" },
      phone: { label: "1-800-204-1685", href: "tel:18002041685", note: "(toll-free in North America)" },
    },
    {
      name: "New Brunswick",
      product: "Student Financial Services",
      site: { label: "www.gnb.ca", href: "https://www.gnb.ca/" },
      phone: { label: "1-800-667-5626", href: "tel:18006675626" },
    },
    {
      name: "Saskatchewan",
      product: "Student Loans",
      site: { label: "www.saskatchewan.ca", href: "https://www.saskatchewan.ca/studentloans" },
      phone: { label: "1-800-597-8278", href: "tel:18005978278" },
    },
    {
      name: "Yukon",
      product: "Student Financial Assistance",
      site: { label: "yukon.ca/en/education-and-schools", href: "https://yukon.ca/en/education-and-schools" },
      phone: { label: "1-867-667-5929", href: "tel:18676675929" },
    },
    {
      name: "Newfoundland and Labrador",
      product: "Student Aid",
      site: { label: "www.aesl.gov.nl.ca", href: "https://www.gov.nl.ca/education/studentaid/" },
      phone: { label: "1-888-657-0800", href: "tel:18886570800", note: "(toll-free)" },
    },
    {
      name: "Northwest Territories",
      product: "Student Financial Assistance",
      site: { label: "www.ece.gov.nt.ca", href: "https://www.ece.gov.nt.ca/en/services/student-financial-assistance" },
      phone: { label: "1-800-661-0793", href: "tel:18006610793", note: "(toll-free)" },
    },
    {
      name: "Nova Scotia",
      product: "Student Assistance",
      site: { label: "novascotia.ca", href: "https://www.novascotia.ca/" },
      phone: { label: "1-800-565-8420", href: "tel:18005658420", note: "(toll-free in Canada)" },
    },
    {
      name: "Nunavut",
      product: "Financial Assistance for Nunavut Students (FANS)",
      site: { label: "gov.nu.ca", href: "https://www.gov.nu.ca/en/education-and-schools/student-funding" },
      phone: { label: "1-877-860-0680", href: "tel:18778600680" },
    },
  ],
  closing: CLOSING_NAVIGATE,
};

// post-85736
export const CARDIOLOGY_BURSARY = {
  hero: {
    eyebrow: "Financial Aid",
    title: "Start Your Cardiology Technologist Career\u2013$3,000 Bursary Available*",
    image: "/assets/heroes/cardiology-bursary-hero.webp",
  },
  bursaryHighlight:
    "Anderson College is excited to offer an exclusive $3,000 bursary for new full-time students enrolling in our Cardiology Technologist program starting February 1, 2027.*",
  intro: [
    "We know that investing in your education is a big step, and we\u2019re here to support you\u2014both financially and academically.",
    "Our program combines expert instruction, hands-on training, and a supportive learning environment to prepare you for success. And the results speak for themselves:",
  ],
  stats: [
    "100% pass rate on the CSCT exam for Anderson graduates",
    "78% average score, surpassing the national average of 74%",
    "Top exam score in Canada (85%) achieved by an Anderson graduate",
  ],
  pull:
    "With high-caliber faculty and a reputation for excellence, Anderson College is committed to helping you launch a successful career in this high-demand field.",
  startDate: {
    heading: "Upcoming Start Date \u2013 February 1, 2027",
    body: "Don\u2019t wait\u2014apply now and take advantage of this limited-time bursary to start your journey toward a future in cardiology technology.",
    cta: { label: "Admission Requirements & Next Steps", href: "/admissions/how-to-apply" },
  },
  note: "*The bursary is pro-rated if the student withdraws. Conditions apply.",
  closing: CLOSING_NAVIGATE,
};


// ─────────────────────── Alternative Student Financing ───────────────────────
// Source: /app/memory/Anderson Student Financing Guide — November 2026 (final).pdf
// Published 2026-02-19 at admin request. Content is "information only — confirm
// details with each lender". Deliberately contains NO guaranteed figures; every
// rate / limit cites the original PDF wording ("reported", "up to", "published").
// Note: this page intentionally references OSAP and government grants in a
// de-emphasised banner per admin direction; they are NOT the current priority
// path, so students are routed to bank + credit-union + microlender options first.
export const ALT_FINANCING = {
  hero: {
    eyebrow: "Financial Aid",
    title: "Alternative Student Financing Options",
    subtitle:
      "A practical guide to private lenders, credit unions and microlending partners. Government student loan programs are not a current priority — this page focuses on options available right now while you confirm eligibility with each provider.",
    image: "/assets/heroes/student-lines-of-credit-hero.png",
    mobileImage: "/assets/heroes/student-lines-of-credit-hero-mobile.png",
  },
  disclaimer:
    "This guide is general information, not financial advice or a promise of funding. No lender listed here has been confirmed to approve every Anderson College program. Each lender decides school, program and applicant eligibility. All figures, rates, conditions and links should be checked directly with the provider before applying.",
  priorityBanner: {
    heading: "Government student loan programs are not the current priority",
    body:
      "Provincial and federal student loan programs (including OSAP) are not currently a focus for Anderson College students. The options below are the alternatives we recommend exploring first while government funding routes remain uncertain.",
  },
  startSteps: [
    {
      step: "1",
      title: "Check eligibility",
      body: "Ask whether Anderson College, your exact program and current study status qualify.",
    },
    {
      step: "2",
      title: "Prepare documents",
      body: "Ask your lender for its full document checklist. Common items include ID, enrolment proof, tuition details and income records.",
    },
    {
      step: "3",
      title: "Compare written offers",
      body: "Confirm the rate, monthly payment, co-signer obligations and when funds will arrive.",
    },
  ],
  optionsAtGlance: [
    { provider: "BMO", type: "Student line of credit", confirm: "School and program eligibility; limit; co-signer", site: { label: "bmo.com", href: "https://www.bmo.com" } },
    { provider: "TD Canada Trust", type: "Student line of credit", confirm: "Program category; co-signer; interest rate", site: { label: "td.com", href: "https://www.td.com" } },
    { provider: "Scotiabank", type: "ScotiaLine for Students", confirm: "Diploma/certificate category; interest payments", site: { label: "scotiabank.com", href: "https://www.scotiabank.com" } },
    { provider: "RBC", type: "Royal Credit Line for Students", confirm: "Institution eligibility; credit limit; guarantor", site: { label: "rbcroyalbank.com", href: "https://www.rbcroyalbank.com" } },
    { provider: "CIBC", type: "Education line of credit", confirm: "Eligible school; borrowing limit; repayment", site: { label: "cibc.com", href: "https://www.cibc.com" } },
    { provider: "Windmill Microlending", type: "Career development loan", confirm: "Newcomer/immigrant criteria; eligible career plan", site: { label: "windmillmicrolending.org", href: "https://windmillmicrolending.org" } },
  ],
  optionsNote:
    "These are enquiry options, not confirmed Anderson College lending arrangements. A published maximum is not a guaranteed offer. The amount available may depend on your program length, credit review and lender rules.",
  windmillCheck: {
    heading: "Windmill Microlending — Anderson Student Eligibility Check",
    body:
      "Check your eligibility using Anderson's dedicated Windmill assessment. This is separate from Windmill's general website and does not guarantee eligibility or loan approval — additional application steps may be required.",
    cta: {
      label: "Start the Windmill eligibility assessment",
      href: "https://event.windmillmicrolending.org/?RR_WCID=4233BA8C-A2CA-46D6-8140-B7527C4D1A35&RR_WCID_TTL=396&REFERRALCODE=ANDERSON&utm_campaign=Need+a+loan+Active#personal-details",
      external: true,
    },
  },
  internationallyTrained: {
    heading: "Additional Financing for Internationally Trained Professionals",
    body:
      "Achēv / Meridian — Accelerating Career Advancement: microloans of up to $30,000 may be available to eligible internationally trained Ontario residents who are Canadian citizens, permanent residents or convention refugees. Income evidence or a guarantor/co-signer is required. Confirm the current interest rate, eligible expenses and whether your Anderson College program and tuition qualify. Funding and approval are not guaranteed.",
  },
  scholarships: {
    heading: "Other Funding Options — Scholarships",
    body:
      "Scholarships, including Desjardins scholarships (desjardins.com), may also be available. They are competitive, eligibility-based and not a source of immediate funding.",
  },
  creditUnions: {
    heading: "Other Financing Options — Credit Unions",
    intro:
      "The following credit unions are additional financing options to explore. They are not confirmed Anderson College financing partners. Check Ontario availability, membership, program eligibility, rates and guarantor requirements directly.",
    rows: [
      { name: "Oshawa Community", detail: "Lists career colleges; up to $10,000 per school year and $50,000 total for eligible full-time students." },
      { name: "RCU (Resurrection)", detail: "Student line up to $60,000 total; membership and acceptable guarantor/co-signer required. Some private schools excluded; college limits vary by study length." },
      { name: "Desjardins", detail: "Up to $10,000 per year, $40,000 total; reported Prime + 2%; confirm Ontario access." },
      { name: "Coast Capital", detail: "Published certificate/diploma eligibility; up to $40,000 for other undergraduate programs, reported Prime + 2%." },
      { name: "Ukrainian Credit Union", detail: "Up to $10,000 per year and $40,000 total; confirm accredited-school eligibility." },
      { name: "Alterna Savings", detail: "Offers student line of credit; confirm eligible school, rate, limit and guarantor." },
      { name: "FirstOntario", detail: "Offers personal loans and lines of credit; ask whether tuition financing is available for your program and confirm terms." },
      { name: "Meridian", detail: "Offers student lines of credit; confirm school and program eligibility, membership, lending requirements and rates." },
      { name: "DUCA", detail: "Confirm current student lending products, eligible schools, membership and rates." },
    ],
    note: "Published figures are indicative and subject to confirmation directly with each credit union.",
  },
  lenderDetails: {
    heading: "Lender Details — What to Expect",
    intro:
      "Figures below are indicative terms and may change. Ask each lender for a current written quote and confirmation that Anderson College and your program qualify.",
    rows: [
      { name: "BMO", detail: "Student line of credit; up to $20,000/year and $80,000 over four years; variable rate reported as Prime + 0.50%; interest-only in school and potentially two years after graduation." },
      { name: "TD", detail: "Student line of credit; up to $20,000/year and $80,000 over four years; reported margins Prime + 1.00% or + 1.50% depending on program category; college applicants generally need a co-signer." },
      { name: "Scotiabank", detail: "ScotiaLine for Students; diploma category may allow up to $20,000/year and $80,000 total; reported Prime + 0.50%; interest-only period may extend 12 months after study." },
      { name: "RBC", detail: "Royal Credit Line for Students; amount and rate depend on program and assessment; a guarantor may be required." },
      { name: "CIBC", detail: "Education Line of Credit; published full-time guideline up to $20,000/year and $80,000 total; rate quoted individually; interest-only while studying, with post-study rules." },
      { name: "Windmill", detail: "Career development loan for eligible newcomers and internationally trained applicants; regular program up to $15,000; reported general fixed rate 5.95%." },
    ],
    note:
      "Prime + margin means a variable rate. Example: if a lender prime rate were 5% and the margin 0.50%, the rate would be 5.50%. The actual prime rate must be checked with that lender.",
  },
  prepareForAppointment: {
    heading: "Prepare for Your Lender Appointment",
    rows: [
      { bring: "Identification", examples: "Valid original government-issued photo ID. Ask which types the lender accepts." },
      { bring: "College documents", examples: "Acceptance/enrolment letter, exact program name, full-time or part-time status, start/end dates, tuition invoice and due dates." },
      { bring: "Income or support", examples: "Recent pay stubs and employer letter, or applicable tax returns, benefit statements, scholarship/RESP information or other verified support." },
      { bring: "Address and budget", examples: "Recent proof of address; monthly income and essential expenses; remaining tuition, books, equipment and other confirmed funding." },
      { bring: "Co-signer, if required", examples: "Their identification, income, debts and other documents requested by the lender. They may be responsible if you cannot repay." },
    ],
    note: "Ask the lender for its exact checklist before visiting. Do not email sensitive identity or tax documents unless the lender provides a secure method.",
  },
  questionsToAsk: {
    heading: "Questions to Ask Before You Apply",
    items: [
      "Will you finance Anderson College, my exact program and current enrolment status, including any class pause? How is my program classified?",
      "How much could I receive for the remaining study period, and will the money arrive before my tuition deadline?",
      "What is the annual interest rate today? Is it fixed or variable? Are there fees?",
      "What would I pay each month while studying, and when must I start repaying the amount borrowed?",
      "Is a co-signer required? Will applying trigger a credit check that could affect my credit score?",
      "What happens to my loan if classes remain paused, I withdraw, or government funding becomes available later?",
    ],
    script: "I am an Anderson College student in the [program name] program. My current study status is [active/temporarily paused]. Do you offer financing for my college and program? What documents would you need, and when could funds be available?",
  },
  faqs: {
    heading: "Common Student Questions",
    items: [
      {
        q: "Am I guaranteed to qualify because I attend Anderson College?",
        a: "No. Each lender checks your program, enrolment status, finances and credit criteria. Confirm eligibility before applying.",
      },
      {
        q: "Where should I apply?",
        a: "Start with your bank or another lender in the options table above. Book an appointment or visit its website. Anderson students can also use the dedicated Windmill eligibility assessment link above.",
      },
      {
        q: "What if I am unemployed or do not have a co-signer?",
        a: "Ask how the lender assesses your income and whether a co-signer is required. Approval is not guaranteed.",
      },
      {
        q: "Will I pay anything while studying?",
        a: "Often, yes. Interest-only means you pay interest without yet repaying the amount borrowed. Ask for a monthly estimate.",
      },
      {
        q: "Can I apply while my classes are paused?",
        a: "Ask the lender whether your current enrolment and study status qualify. A pause may affect eligibility or repayment.",
      },
      {
        q: "What if government funding becomes available later?",
        a: "You still owe the lender. Ask about early repayment and whether borrowing could affect a future government-aid assessment.",
      },
      {
        q: "Will funds go to me or directly to Anderson College?",
        a: "It depends on the lender. Confirm how and when funds are released, especially if tuition is due soon.",
      },
      {
        q: "Will applying affect my credit?",
        a: "Some applications involve a credit check that may affect your score. Ask before applying, particularly to several lenders.",
      },
      {
        q: "What if I am declined?",
        a: "Ask why and whether a smaller loan, co-signer or another option could work. Scholarships may help but are not guaranteed or immediate.",
      },
    ],
  },
  beforeAccepting: {
    heading: "Before Accepting an Offer",
    body:
      "Compare written terms, not just the advertised rate. Check your total borrowing cost, fees, payment dates, variable-rate risk and co-signer responsibilities. Borrow only what you need and can reasonably repay.",
  },
  closing: CLOSING_NAVIGATE,
};
